/*!
 * Flickity PACKAGED v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */
!function(t,e){"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,(function(t,e){let i=t.console,s=void 0===i?function(){}:function(t){i.error(t)};return function(i,n,o){(o=o||e||t.jQuery)&&(n.prototype.option||(n.prototype.option=function(t){t&&(this.options=Object.assign(this.options||{},t))}),o.fn[i]=function(t,...e){return"string"==typeof t?function(t,e,n){let l,r=`$().${i}("${e}")`;return t.each((function(t,h){let a=o.data(h,i);if(!a)return void s(`${i} not initialized. Cannot call method ${r}`);let c=a[e];if(!c||"_"==e.charAt(0))return void s(`${r} is not a valid method`);let d=c.apply(a,n);l=void 0===l?d:l})),void 0!==l?l:t}(this,t,e):(l=t,this.each((function(t,e){let s=o.data(e,i);s?(s.option(l),s._init()):(s=new n(e,l),o.data(e,i,s))})),this);var l})}})),function(t,e){"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,(function(){function t(){}let e=t.prototype;return e.on=function(t,e){if(!t||!e)return this;let i=this._events=this._events||{},s=i[t]=i[t]||[];return s.includes(e)||s.push(e),this},e.once=function(t,e){if(!t||!e)return this;this.on(t,e);let i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this},e.off=function(t,e){let i=this._events&&this._events[t];if(!i||!i.length)return this;let s=i.indexOf(e);return-1!=s&&i.splice(s,1),this},e.emitEvent=function(t,e){let i=this._events&&this._events[t];if(!i||!i.length)return this;i=i.slice(0),e=e||[];let s=this._onceEvents&&this._onceEvents[t];for(let n of i){s&&s[n]&&(this.off(t,n),delete s[n]),n.apply(this,e)}return this},e.allOff=function(){return delete this._events,delete this._onceEvents,this},t})),
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */
function(t,e){"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,(function(){function t(t){let e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}let e=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"];e.length;return function(i){if("string"==typeof i&&(i=document.querySelector(i)),!(i&&"object"==typeof i&&i.nodeType))return;let s=getComputedStyle(i);if("none"==s.display)return function(){let t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0};return e.forEach((e=>{t[e]=0})),t}();let n={};n.width=i.offsetWidth,n.height=i.offsetHeight;let o=n.isBorderBox="border-box"==s.boxSizing;e.forEach((t=>{let e=s[t],i=parseFloat(e);n[t]=isNaN(i)?0:i}));let l=n.paddingLeft+n.paddingRight,r=n.paddingTop+n.paddingBottom,h=n.marginLeft+n.marginRight,a=n.marginTop+n.marginBottom,c=n.borderLeftWidth+n.borderRightWidth,d=n.borderTopWidth+n.borderBottomWidth,u=t(s.width);!1!==u&&(n.width=u+(o?0:l+c));let p=t(s.height);return!1!==p&&(n.height=p+(o?0:r+d)),n.innerWidth=n.width-(l+c),n.innerHeight=n.height-(r+d),n.outerWidth=n.width+h,n.outerHeight=n.height+a,n}})),function(t,e){"object"==typeof module&&module.exports?module.exports=e(t):t.fizzyUIUtils=e(t)}(this,(function(t){let e={extend:function(t,e){return Object.assign(t,e)},modulo:function(t,e){return(t%e+e)%e},makeArray:function(t){if(Array.isArray(t))return t;if(null==t)return[];return"object"==typeof t&&"number"==typeof t.length?[...t]:[t]},removeFrom:function(t,e){let i=t.indexOf(e);-1!=i&&t.splice(i,1)},getParent:function(t,e){for(;t.parentNode&&t!=document.body;)if((t=t.parentNode).matches(e))return t},getQueryElement:function(t){return"string"==typeof t?document.querySelector(t):t},handleEvent:function(t){let e="on"+t.type;this[e]&&this[e](t)},filterFindElements:function(t,i){return(t=e.makeArray(t)).filter((t=>t instanceof HTMLElement)).reduce(((t,e)=>{if(!i)return t.push(e),t;e.matches(i)&&t.push(e);let s=e.querySelectorAll(i);return t=t.concat(...s)}),[])},debounceMethod:function(t,e,i){i=i||100;let s=t.prototype[e],n=e+"Timeout";t.prototype[e]=function(){clearTimeout(this[n]);let t=arguments;this[n]=setTimeout((()=>{s.apply(this,t),delete this[n]}),i)}},docReady:function(t){let e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},toDashed:function(t){return t.replace(/(.)([A-Z])/g,(function(t,e,i){return e+"-"+i})).toLowerCase()}},i=t.console;return e.htmlInit=function(s,n){e.docReady((function(){let o="data-"+e.toDashed(n),l=document.querySelectorAll(`[${o}]`),r=t.jQuery;[...l].forEach((t=>{let e,l=t.getAttribute(o);try{e=l&&JSON.parse(l)}catch(e){return void(i&&i.error(`Error parsing ${o} on ${t.className}: ${e}`))}let h=new s(t,e);r&&r.data(t,n,h)}))}))},e})),
/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */
function(t,e){"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.Unidragger=e(t,t.EvEmitter)}("undefined"!=typeof window?window:this,(function(t,e){function i(){}let s=i.prototype=Object.create(e.prototype);s.handleEvent=function(t){let e="on"+t.type;this[e]&&this[e](t)};let n,o,l=!1;"ontouchstart"in t?(l=!0,n="touchstart",o=["touchmove","touchend","touchcancel"]):t.PointerEvent?(n="pointerdown",o=["pointermove","pointerup","pointercancel"]):(n="mousedown",o=["mousemove","mouseup"]),s.touchActionValue="none",s.bindHandles=function(){this._bindHandles("addEventListener",this.touchActionValue)},s.unbindHandles=function(){this._bindHandles("removeEventListener","")},s._bindHandles=function(e,i){this.handles.forEach((s=>{s[e](n,this,{passive:l}),s[e]("click",this),t.PointerEvent&&(s.style.touchAction=i)}))},s.bindActivePointerEvents=function(){o.forEach((e=>{t.addEventListener(e,this)}))},s.unbindActivePointerEvents=function(){o.forEach((e=>{t.removeEventListener(e,this)}))},s.withPointer=function(t,e){e.pointerId===this.pointerIdentifier&&this[t](e,e)},s.withTouch=function(t,e){let i;for(let t of e.changedTouches)t.identifier===this.pointerIdentifier&&(i=t);i&&this[t](e,i)},s.onmousedown=function(t){this.pointerDown(t,t)},s.ontouchstart=function(t){this.pointerDown(t,t.changedTouches[0])},s.onpointerdown=function(t){this.pointerDown(t,t)};const r=["TEXTAREA","INPUT","SELECT","OPTION"],h=["radio","checkbox","button","submit","image","file"];return s.pointerDown=function(t,e){let i=r.includes(t.target.nodeName),s=h.includes(t.target.type),n=!i||s;!this.isPointerDown&&!t.button&&n&&(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},this.bindActivePointerEvents(),this.emitEvent("pointerDown",[t,e]))},s.onmousemove=function(t){this.pointerMove(t,t)},s.onpointermove=function(t){this.withPointer("pointerMove",t)},s.ontouchmove=function(t){this.withTouch("pointerMove",t)},s.pointerMove=function(t,e){let i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};this.emitEvent("pointerMove",[t,e,i]),!this.isDragging&&this.hasDragStarted(i)&&this.dragStart(t,e),this.isDragging&&this.dragMove(t,e,i)},s.hasDragStarted=function(t){return Math.abs(t.x)>3||Math.abs(t.y)>3},s.dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.emitEvent("dragStart",[t,e])},s.dragMove=function(t,e,i){this.emitEvent("dragMove",[t,e,i])},s.onmouseup=function(t){this.pointerUp(t,t)},s.onpointerup=function(t){this.withPointer("pointerUp",t)},s.ontouchend=function(t){this.withTouch("pointerUp",t)},s.pointerUp=function(t,e){this.pointerDone(),this.emitEvent("pointerUp",[t,e]),this.isDragging?this.dragEnd(t,e):this.staticClick(t,e)},s.dragEnd=function(t,e){this.isDragging=!1,setTimeout((()=>delete this.isPreventingClicks)),this.emitEvent("dragEnd",[t,e])},s.pointerDone=function(){this.isPointerDown=!1,delete this.pointerIdentifier,this.unbindActivePointerEvents(),this.emitEvent("pointerDone")},s.onpointercancel=function(t){this.withPointer("pointerCancel",t)},s.ontouchcancel=function(t){this.withTouch("pointerCancel",t)},s.pointerCancel=function(t,e){this.pointerDone(),this.emitEvent("pointerCancel",[t,e])},s.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},s.staticClick=function(t,e){let i="mouseup"===t.type;i&&this.isIgnoringMouseUp||(this.emitEvent("staticClick",[t,e]),i&&(this.isIgnoringMouseUp=!0,setTimeout((()=>{delete this.isIgnoringMouseUp}),400)))},i})),
/*!
 * Flickity main
 * Cell, slide, animate
 */
function(t,e){"object"==typeof module&&module.exports?module.exports=e(require("get-size")):(t.Flickity=t.Flickity||{},t.Flickity.Cell=e(t.getSize))}("undefined"!=typeof window?window:this,(function(t){const e="flickity-cell";function i(t){this.element=t,this.element.classList.add(e),this.x=0,this.unselect()}let s=i.prototype;return s.destroy=function(){this.unselect(),this.element.classList.remove(e),this.element.style.transform="",this.element.removeAttribute("aria-hidden")},s.getSize=function(){this.size=t(this.element)},s.select=function(){this.element.classList.add("is-selected"),this.element.removeAttribute("aria-hidden")},s.unselect=function(){this.element.classList.remove("is-selected"),this.element.setAttribute("aria-hidden","true")},s.remove=function(){this.element.remove()},i})),function(t,e){"object"==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e())}("undefined"!=typeof window?window:this,(function(){function t(t,e,i){this.beginMargin=t,this.endMargin=e,this.cellAlign=i,this.cells=[],this.outerWidth=0,this.height=0}let e=t.prototype;return e.addCell=function(t){this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1===this.cells.length&&(this.x=t.x,this.firstMargin=t.size[this.beginMargin])},e.updateTarget=function(){let t=this.getLastCell(),e=t?t.size[this.endMargin]:0,i=this.outerWidth-(this.firstMargin+e);this.target=this.x+this.firstMargin+i*this.cellAlign},e.getLastCell=function(){return this.cells[this.cells.length-1]},e.select=function(){this.cells.forEach((t=>t.select()))},e.unselect=function(){this.cells.forEach((t=>t.unselect()))},e.getCellElements=function(){return this.cells.map((t=>t.element))},t})),function(t,e){"object"==typeof module&&module.exports?module.exports=e(require("fizzy-ui-utils")):(t.Flickity=t.Flickity||{},t.Flickity.animatePrototype=e(t.fizzyUIUtils))}("undefined"!=typeof window?window:this,(function(t){let e={startAnimation:function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},animate:function(){this.applyDragForce(),this.applySelectedAttraction();let t=this.x;this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating&&requestAnimationFrame((()=>this.animate()))},positionSlider:function(){let e=this.x;this.isWrapping&&(e=t.modulo(e,this.slideableWidth)-this.slideableWidth,this.shiftWrapCells(e)),this.setTranslateX(e,this.isAnimating),this.dispatchScrollEvent()},setTranslateX:function(t,e){t+=this.cursorPosition,this.options.rightToLeft&&(t=-t);let i=this.getPositionValue(t);this.slider.style.transform=e?`translate3d(${i},0,0)`:`translateX(${i})`},dispatchScrollEvent:function(){let t=this.slides[0];if(!t)return;let e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent("scroll",null,[i,e])},positionSliderAtSelected:function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider())},getPositionValue:function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},settle:function(t){!this.isPointerDown&&Math.round(100*this.x)===Math.round(100*t)&&this.restingFrames++,this.restingFrames>2&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},shiftWrapCells:function(t){let e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);let i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},_shiftCells:function(t,e,i){t.forEach((t=>{let s=e>0?i:0;this._wrapShiftCell(t,s),e-=t.size.outerWidth}))},_unshiftCells:function(t){t&&t.length&&t.forEach((t=>this._wrapShiftCell(t,0)))},_wrapShiftCell:function(t,e){this._renderCellPosition(t,t.x+this.slideableWidth*e)},integratePhysics:function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},applyForce:function(t){this.velocity+=t},getFrictionFactor:function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},getRestingPosition:function(){return this.x+this.velocity/(1-this.getFrictionFactor())},applyDragForce:function(){if(!this.isDraggable||!this.isPointerDown)return;let t=this.dragX-this.x-this.velocity;this.applyForce(t)},applySelectedAttraction:function(){if(this.isDraggable&&this.isPointerDown||this.isFreeScrolling||!this.slides.length)return;let t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t)}};return e})),function(t,e){if("object"==typeof module&&module.exports)module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{let i=t.Flickity;t.Flickity=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,i.Cell,i.Slide,i.animatePrototype)}}("undefined"!=typeof window?window:this,(function(t,e,i,s,n,o,l){const{getComputedStyle:r,console:h}=t;let{jQuery:a}=t,c=0,d={};function u(t,e){let i=s.getQueryElement(t);if(i){if(this.element=i,this.element.flickityGUID){let t=d[this.element.flickityGUID];return t&&t.option(e),t}a&&(this.$element=a(this.element)),this.options={...this.constructor.defaults},this.option(e),this._create()}else h&&h.error(`Bad element for Flickity: ${i||t}`)}u.defaults={accessibility:!0,cellAlign:"center",freeScrollFriction:.075,friction:.28,namespaceJQueryEvents:!0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},u.create={};let p=u.prototype;Object.assign(p,e.prototype),p._create=function(){let{resize:e,watchCSS:i,rightToLeft:s}=this.options,n=this.guid=++c;this.element.flickityGUID=n,d[n]=this,this.selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.beginMargin=s?"marginRight":"marginLeft",this.endMargin=s?"marginLeft":"marginRight",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),this.focusableElems=[this.element],(e||i)&&t.addEventListener("resize",this);for(let t in this.options.on){let e=this.options.on[t];this.on(t,e)}for(let t in u.create)u.create[t].call(this);i?this.watchCSS():this.activate()},p.option=function(t){Object.assign(this.options,t)},p.activate=function(){if(this.isActive)return;this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize();let t=this._filterFindCellElements(this.element.children);this.slider.append(...t),this.viewport.append(this.slider),this.element.append(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate"),this.selectInitialIndex(),this.isInitActivated=!0,this.dispatchEvent("ready")},p._createSlider=function(){let t=document.createElement("div");t.className="flickity-slider",this.slider=t},p._filterFindCellElements=function(t){return s.filterFindElements(t,this.options.cellSelector)},p.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._updateWrapShiftCells(),this.setGallerySize()},p._makeCells=function(t){return this._filterFindCellElements(t).map((t=>new n(t)))},p.getLastCell=function(){return this.cells[this.cells.length-1]},p.getLastSlide=function(){return this.slides[this.slides.length-1]},p.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},p._positionCells=function(t){t=t||0,this.maxCellHeight=t&&this.maxCellHeight||0;let e=0;if(t>0){let i=this.cells[t-1];e=i.x+i.size.outerWidth}this.cells.slice(t).forEach((t=>{t.x=e,this._renderCellPosition(t,e),e+=t.size.outerWidth,this.maxCellHeight=Math.max(t.size.outerHeight,this.maxCellHeight)})),this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=this.cells.length?this.getLastSlide().target-this.slides[0].target:0},p._renderCellPosition=function(t,e){let i=e*(this.options.rightToLeft?-1:1);this.options.percentPosition&&(i*=this.size.innerWidth/t.size.width);let s=this.getPositionValue(i);t.element.style.transform=`translateX( ${s} )`},p._sizeCells=function(t){t.forEach((t=>t.getSize()))},p.updateSlides=function(){if(this.slides=[],!this.cells.length)return;let{beginMargin:t,endMargin:e}=this,i=new o(t,e,this.cellAlign);this.slides.push(i);let s=this._getCanCellFit();this.cells.forEach(((n,l)=>{if(!i.cells.length)return void i.addCell(n);let r=i.outerWidth-i.firstMargin+(n.size.outerWidth-n.size[e]);s(l,r)||(i.updateTarget(),i=new o(t,e,this.cellAlign),this.slides.push(i)),i.addCell(n)})),i.updateTarget(),this.updateSelectedSlide()},p._getCanCellFit=function(){let{groupCells:t}=this.options;if(!t)return()=>!1;if("number"==typeof t){let e=parseInt(t,10);return t=>t%e!=0}let e=1,i="string"==typeof t&&t.match(/^(\d+)%$/);i&&(e=parseInt(i[1],10)/100);let s=(this.size.innerWidth+1)*e;return(t,e)=>e<=s},p._init=p.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},p.getSize=function(){this.size=i(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};let f={left:0,center:.5,right:1};p.setCellAlign=function(){let{cellAlign:t,rightToLeft:e}=this.options,i=f[t];this.cellAlign=void 0!==i?i:t,e&&(this.cellAlign=1-this.cellAlign)},p.setGallerySize=function(){if(!this.options.setGallerySize)return;let t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=`${t}px`},p._updateWrapShiftCells=function(){if(this.isWrapping=this.getIsWrapping(),!this.isWrapping)return;this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);let t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1);let i=this.size.innerWidth-this.cursorPosition;this.afterShiftCells=this._getGapCells(i,0,1)},p.getIsWrapping=function(){let{wrapAround:t}=this.options;if(!t||this.slides.length<2)return!1;if("fill"!==t)return!0;let e=this.slideableWidth-this.size.innerWidth;if(e>this.size.innerWidth)return!0;for(let t of this.cells)if(t.size.outerWidth>e)return!1;return!0},p._getGapCells=function(t,e,i){let s=[];for(;t>0;){let n=this.cells[e];if(!n)break;s.push(n),e+=i,t-=n.size.outerWidth}return s},p._containSlides=function(){if(!(this.options.contain&&!this.isWrapping&&this.cells.length))return;let t=this.slideableWidth-this.getLastCell().size[this.endMargin];if(t<this.size.innerWidth)this.slides.forEach((e=>{e.target=t*this.cellAlign}));else{let e=this.cursorPosition+this.cells[0].size[this.beginMargin],i=t-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach((t=>{t.target=Math.max(t.target,e),t.target=Math.min(t.target,i)}))}},p.dispatchEvent=function(t,e,i){let s=e?[e].concat(i):i;if(this.emitEvent(t,s),a&&this.$element){let s=t+=this.options.namespaceJQueryEvents?".flickity":"";if(e){let i=new a.Event(e);i.type=t,s=i}this.$element.trigger(s,i)}};const g=["dragStart","dragMove","dragEnd","pointerDown","pointerMove","pointerEnd","staticClick"];let m=p.emitEvent;p.emitEvent=function(t,e){if("staticClick"===t){let t=this.getParentCell(e[0].target),i=t&&t.element,s=t&&this.cells.indexOf(t);e=e.concat(i,s)}if(m.call(this,t,e),!g.includes(t)||!a||!this.$element)return;t+=this.options.namespaceJQueryEvents?".flickity":"";let i=e.shift(0),s=new a.Event(i);s.type=t,this.$element.trigger(s,e)},p.select=function(t,e,i){if(!this.isActive)return;if(t=parseInt(t,10),this._wrapSelect(t),(this.isWrapping||e)&&(t=s.modulo(t,this.slides.length)),!this.slides[t])return;let n=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select",null,[t]),t!==n&&this.dispatchEvent("change",null,[t])},p._wrapSelect=function(t){if(!this.isWrapping)return;const{selectedIndex:e,slideableWidth:i,slides:{length:n}}=this;if(!this.isDragSelect){let i=s.modulo(t,n),o=Math.abs(i-e),l=Math.abs(i+n-e),r=Math.abs(i-n-e);l<o?t+=n:r<o&&(t-=n)}t<0?this.x-=i:t>=n&&(this.x+=i)},p.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},p.next=function(t,e){this.select(this.selectedIndex+1,t,e)},p.updateSelectedSlide=function(){let t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),this.selectedSlide=t,t.select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},p.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},p.selectInitialIndex=function(){let t=this.options.initialIndex;if(this.isInitActivated)return void this.select(this.selectedIndex,!1,!0);if(t&&"string"==typeof t){if(this.queryCell(t))return void this.selectCell(t,!1,!0)}let e=0;t&&this.slides[t]&&(e=t),this.select(e,!1,!0)},p.selectCell=function(t,e,i){let s=this.queryCell(t);if(!s)return;let n=this.getCellSlideIndex(s);this.select(n,e,i)},p.getCellSlideIndex=function(t){let e=this.slides.find((e=>e.cells.includes(t)));return this.slides.indexOf(e)},p.getCell=function(t){for(let e of this.cells)if(e.element===t)return e},p.getCells=function(t){return(t=s.makeArray(t)).map((t=>this.getCell(t))).filter(Boolean)},p.getCellElements=function(){return this.cells.map((t=>t.element))},p.getParentCell=function(t){let e=this.getCell(t);if(e)return e;let i=t.closest(".flickity-slider > *");return this.getCell(i)},p.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;let i=this.slides.length;if(1+2*t>=i)return this.getCellElements();let n=[];for(let o=e-t;o<=e+t;o++){let t=this.isWrapping?s.modulo(o,i):o,e=this.slides[t];e&&(n=n.concat(e.getCellElements()))}return n},p.queryCell=function(t){if("number"==typeof t)return this.cells[t];return"string"==typeof t&&!t.match(/^[#.]?[\d/]/)&&(t=this.element.querySelector(t)),this.getCell(t)},p.uiChange=function(){this.emitEvent("uiChange")},p.onresize=function(){this.watchCSS(),this.resize()},s.debounceMethod(u,"onresize",150),p.resize=function(){if(!this.isActive||this.isAnimating||this.isDragging)return;this.getSize(),this.isWrapping&&(this.x=s.modulo(this.x,this.slideableWidth)),this.positionCells(),this._updateWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");let t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)},p.watchCSS=function(){if(!this.options.watchCSS)return;r(this.element,":after").content.includes("flickity")?this.activate():this.deactivate()},p.onkeydown=function(t){let{activeElement:e}=document,i=u.keyboardHandlers[t.key];this.options.accessibility&&e&&i&&this.focusableElems.some((t=>e===t))&&i.call(this)},u.keyboardHandlers={ArrowLeft:function(){this.uiChange(),this[this.options.rightToLeft?"next":"previous"]()},ArrowRight:function(){this.uiChange(),this[this.options.rightToLeft?"previous":"next"]()}},p.focus=function(){this.element.focus({preventScroll:!0})},p.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),this.cells.forEach((t=>t.destroy())),this.viewport.remove(),this.element.append(...this.slider.children),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},p.destroy=function(){this.deactivate(),t.removeEventListener("resize",this),this.allOff(),this.emitEvent("destroy"),a&&this.$element&&a.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete d[this.guid]},Object.assign(p,l),u.data=function(t){if(t=s.getQueryElement(t))return d[t.flickityGUID]},s.htmlInit(u,"flickity");let{jQueryBridget:v}=t;return a&&v&&v("flickity",u,a),u.setJQuery=function(t){a=t},u.Cell=n,u.Slide=o,u})),function(t,e){"object"==typeof module&&module.exports?module.exports=e(t,require("./core"),require("unidragger"),require("fizzy-ui-utils")):t.Flickity=e(t,t.Flickity,t.Unidragger,t.fizzyUIUtils)}("undefined"!=typeof window?window:this,(function(t,e,i,s){Object.assign(e.defaults,{draggable:">1",dragThreshold:3});let n=e.prototype;function o(){return{x:t.pageXOffset,y:t.pageYOffset}}return Object.assign(n,i.prototype),n.touchActionValue="",e.create.drag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable),this.on("pointerDown",this.handlePointerDown),this.on("pointerUp",this.handlePointerUp),this.on("pointerDown",this.handlePointerDone),this.on("dragStart",this.handleDragStart),this.on("dragMove",this.handleDragMove),this.on("dragEnd",this.handleDragEnd),this.on("staticClick",this.handleStaticClick)},n.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},n.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},n.updateDraggable=function(){">1"===this.options.draggable?this.isDraggable=this.slides.length>1:this.isDraggable=this.options.draggable,this.element.classList.toggle("is-draggable",this.isDraggable)},n._uiChangeDrag=function(){delete this.isFreeScrolling},n.handlePointerDown=function(e){if(!this.isDraggable)return void this.bindActivePointerEvents(e);let i="touchstart"===e.type,s="touch"===e.pointerType,n=e.target.matches("input, textarea, select");i||s||n||e.preventDefault(),n||this.focus(),document.activeElement!==this.element&&document.activeElement.blur(),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this.pointerDownScroll=o(),t.addEventListener("scroll",this),this.bindActivePointerEvents(e)},n.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},n.handlePointerUp=function(){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down")},n.handlePointerDone=function(){t.removeEventListener("scroll",this),delete this.pointerDownScroll},n.handleDragStart=function(){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),t.removeEventListener("scroll",this))},n.handleDragMove=function(t,e,i){if(!this.isDraggable)return;t.preventDefault(),this.previousDragX=this.dragX;let s=this.options.rightToLeft?-1:1;this.isWrapping&&(i.x%=this.slideableWidth);let n=this.dragStartPosition+i.x*s;if(!this.isWrapping){let t=Math.max(-this.slides[0].target,this.dragStartPosition);n=n>t?.5*(n+t):n;let e=Math.min(-this.getLastSlide().target,this.dragStartPosition);n=n<e?.5*(n+e):n}this.dragX=n,this.dragMoveTime=new Date},n.handleDragEnd=function(){if(!this.isDraggable)return;let{freeScroll:t}=this.options;t&&(this.isFreeScrolling=!0);let e=this.dragEndRestingSelect();if(t&&!this.isWrapping){let t=this.getRestingPosition();this.isFreeScrolling=-t>this.slides[0].target&&-t<this.getLastSlide().target}else t||e!==this.selectedIndex||(e+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.isWrapping,this.select(e),delete this.isDragSelect},n.dragEndRestingSelect=function(){let t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),s=this._getClosestResting(t,e,-1);return i.distance<s.distance?i.index:s.index},n._getClosestResting=function(t,e,i){let s=this.selectedIndex,n=1/0,o=this.options.contain&&!this.isWrapping?(t,e)=>t<=e:(t,e)=>t<e;for(;o(e,n)&&(s+=i,n=e,null!==(e=this.getSlideDistance(-t,s)));)e=Math.abs(e);return{distance:n,index:s-i}},n.getSlideDistance=function(t,e){let i=this.slides.length,n=this.options.wrapAround&&i>1,o=n?s.modulo(e,i):e,l=this.slides[o];if(!l)return null;let r=n?this.slideableWidth*Math.floor(e/i):0;return t-(l.target+r)},n.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||new Date-this.dragMoveTime>100)return 0;let t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return t>0&&e>0?1:t<0&&e<0?-1:0},n.onscroll=function(){let t=o(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(Math.abs(e)>3||Math.abs(i)>3)&&this.pointerDone()},e})),function(t,e){"object"==typeof module&&module.exports?module.exports=e(require("./core")):e(t.Flickity)}("undefined"!=typeof window?window:this,(function(t){const e="http://www.w3.org/2000/svg";function i(t,e,i){this.increment=t,this.direction=e,this.isPrevious="previous"===t,this.isLeft="left"===e,this._create(i)}i.prototype._create=function(t){let e=this.element=document.createElement("button");e.className=`flickity-button flickity-prev-next-button ${this.increment}`;let i=this.isPrevious?"Previous":"Next";e.setAttribute("type","button"),e.setAttribute("aria-label",i),this.disable();let s=this.createSVG(i,t);e.append(s)},i.prototype.createSVG=function(t,i){let s=document.createElementNS(e,"svg");s.setAttribute("class","flickity-button-icon"),s.setAttribute("viewBox","0 0 100 100");let n=document.createElementNS(e,"title");n.append(t);let o=document.createElementNS(e,"path"),l=function(t){if("string"==typeof t)return t;let{x0:e,x1:i,x2:s,x3:n,y1:o,y2:l}=t;return`M ${e}, 50\n    L ${i}, ${o+50}\n    L ${s}, ${l+50}\n    L ${n}, 50\n    L ${s}, ${50-l}\n    L ${i}, ${50-o}\n    Z`}(i);return o.setAttribute("d",l),o.setAttribute("class","arrow"),this.isLeft||o.setAttribute("transform","translate(100, 100) rotate(180)"),s.append(n,o),s},i.prototype.enable=function(){this.element.removeAttribute("disabled")},i.prototype.disable=function(){this.element.setAttribute("disabled",!0)},Object.assign(t.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),t.create.prevNextButtons=function(){if(!this.options.prevNextButtons)return;let{rightToLeft:t,arrowShape:e}=this.options,s=t?"right":"left",n=t?"left":"right";this.prevButton=new i("previous",s,e),this.nextButton=new i("next",n,e),this.focusableElems.push(this.prevButton.element),this.focusableElems.push(this.nextButton.element),this.handlePrevButtonClick=()=>{this.uiChange(),this.previous()},this.handleNextButtonClick=()=>{this.uiChange(),this.next()},this.on("activate",this.activatePrevNextButtons),this.on("select",this.updatePrevNextButtons)};let s=t.prototype;return s.updatePrevNextButtons=function(){let t=this.slides.length?this.slides.length-1:0;this.updatePrevNextButton(this.prevButton,0),this.updatePrevNextButton(this.nextButton,t)},s.updatePrevNextButton=function(t,e){if(this.isWrapping&&this.slides.length>1)return void t.enable();let i=this.selectedIndex!==e;t[i?"enable":"disable"](),!i&&document.activeElement===t.element&&this.focus()},s.activatePrevNextButtons=function(){this.prevButton.element.addEventListener("click",this.handlePrevButtonClick),this.nextButton.element.addEventListener("click",this.handleNextButtonClick),this.element.append(this.prevButton.element,this.nextButton.element),this.on("deactivate",this.deactivatePrevNextButtons)},s.deactivatePrevNextButtons=function(){this.prevButton.element.remove(),this.nextButton.element.remove(),this.prevButton.element.removeEventListener("click",this.handlePrevButtonClick),this.nextButton.element.removeEventListener("click",this.handleNextButtonClick),this.off("deactivate",this.deactivatePrevNextButtons)},t.PrevNextButton=i,t})),function(t,e){"object"==typeof module&&module.exports?module.exports=e(require("./core"),require("fizzy-ui-utils")):e(t.Flickity,t.fizzyUIUtils)}("undefined"!=typeof window?window:this,(function(t,e){function i(){this.holder=document.createElement("div"),this.holder.className="flickity-page-dots",this.dots=[]}i.prototype.setDots=function(t){let e=t-this.dots.length;e>0?this.addDots(e):e<0&&this.removeDots(-e)},i.prototype.addDots=function(t){let e=new Array(t).fill().map(((t,e)=>{let i=document.createElement("button");i.setAttribute("type","button");let s=e+1+this.dots.length;return i.className="flickity-page-dot",i.textContent=`View slide ${s}`,i}));this.holder.append(...e),this.dots=this.dots.concat(e)},i.prototype.removeDots=function(t){this.dots.splice(this.dots.length-t,t).forEach((t=>t.remove()))},i.prototype.updateSelected=function(t){this.selectedDot&&(this.selectedDot.classList.remove("is-selected"),this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[t],this.selectedDot.classList.add("is-selected"),this.selectedDot.setAttribute("aria-current","step"))},t.PageDots=i,Object.assign(t.defaults,{pageDots:!0}),t.create.pageDots=function(){this.options.pageDots&&(this.pageDots=new i,this.handlePageDotsClick=this.onPageDotsClick.bind(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))};let s=t.prototype;return s.activatePageDots=function(){this.pageDots.setDots(this.slides.length),this.focusableElems.push(...this.pageDots.dots),this.pageDots.holder.addEventListener("click",this.handlePageDotsClick),this.element.append(this.pageDots.holder)},s.onPageDotsClick=function(t){let e=this.pageDots.dots.indexOf(t.target);-1!==e&&(this.uiChange(),this.select(e))},s.updateSelectedPageDots=function(){this.pageDots.updateSelected(this.selectedIndex)},s.updatePageDots=function(){this.pageDots.dots.forEach((t=>{e.removeFrom(this.focusableElems,t)})),this.pageDots.setDots(this.slides.length),this.focusableElems.push(...this.pageDots.dots)},s.deactivatePageDots=function(){this.pageDots.holder.remove(),this.pageDots.holder.removeEventListener("click",this.handlePageDotsClick)},t.PageDots=i,t})),function(t,e){"object"==typeof module&&module.exports?module.exports=e(require("./core")):e(t.Flickity)}("undefined"!=typeof window?window:this,(function(t){function e(t,e){this.autoPlay=t,this.onTick=e,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}e.prototype.play=function(){if("playing"===this.state)return;document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick())},e.prototype.tick=function(){if("playing"!==this.state)return;let t="number"==typeof this.autoPlay?this.autoPlay:3e3;this.clear(),this.timeout=setTimeout((()=>{this.onTick(),this.tick()}),t)},e.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},e.prototype.clear=function(){clearTimeout(this.timeout)},e.prototype.pause=function(){"playing"===this.state&&(this.state="paused",this.clear())},e.prototype.unpause=function(){"paused"===this.state&&this.play()},e.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},e.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},Object.assign(t.defaults,{pauseAutoPlayOnHover:!0}),t.create.player=function(){this.player=new e(this.options.autoPlay,(()=>{this.next(!0)})),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)};let i=t.prototype;return i.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},i.playPlayer=function(){this.player.play()},i.stopPlayer=function(){this.player.stop()},i.pausePlayer=function(){this.player.pause()},i.unpausePlayer=function(){this.player.unpause()},i.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},i.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},i.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},t.Player=e,t})),function(t,e){"object"==typeof module&&module.exports?module.exports=e(require("./core"),require("fizzy-ui-utils")):e(t.Flickity,t.fizzyUIUtils)}("undefined"!=typeof window?window:this,(function(t,e){let i=t.prototype;return i.insert=function(t,e){let i=this._makeCells(t);if(!i||!i.length)return;let s=this.cells.length;e=void 0===e?s:e;let n=function(t){let e=document.createDocumentFragment();return t.forEach((t=>e.appendChild(t.element))),e}(i),o=e===s;if(o)this.slider.appendChild(n);else{let t=this.cells[e].element;this.slider.insertBefore(n,t)}if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{let t=this.cells.splice(e,s-e);this.cells=this.cells.concat(i).concat(t)}this._sizeCells(i),this.cellChange(e),this.positionSliderAtSelected()},i.append=function(t){this.insert(t,this.cells.length)},i.prepend=function(t){this.insert(t,0)},i.remove=function(t){let i=this.getCells(t);if(!i||!i.length)return;let s=this.cells.length-1;i.forEach((t=>{t.remove();let i=this.cells.indexOf(t);s=Math.min(i,s),e.removeFrom(this.cells,t)})),this.cellChange(s),this.positionSliderAtSelected()},i.cellSizeChange=function(t){let e=this.getCell(t);if(!e)return;e.getSize();let i=this.cells.indexOf(e);this.cellChange(i)},i.cellChange=function(t){let e=this.selectedElement;this._positionCells(t),this._updateWrapShiftCells(),this.setGallerySize();let i=this.getCell(e);i&&(this.selectedIndex=this.getCellSlideIndex(i)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),this.select(this.selectedIndex)},t}));
/*!
 * Flickity asNavFor v3.0.0
 * enable asNavFor for Flickity
 */
!function(e,t){"object"==typeof module&&module.exports?module.exports=t(require("flickity"),require("fizzy-ui-utils")):e.Flickity=t(e.Flickity,e.fizzyUIUtils)}(window,function(e,t){e.create.asNavFor=function(){this.on("activate",this.activateAsNavFor),this.on("deactivate",this.deactivateAsNavFor),this.on("destroy",this.destroyAsNavFor);let e=this.options.asNavFor;e&&setTimeout(()=>{this.setNavCompanion(e)})};let n=e.prototype;return n.setNavCompanion=function(n){n=t.getQueryElement(n);let i=e.data(n);i&&i!==this&&(this.navCompanion=i,this.onNavCompanionSelect=(()=>{this.navCompanionSelect()}),i.on("select",this.onNavCompanionSelect),this.on("staticClick",this.onNavStaticClick),this.navCompanionSelect(!0))},n.navCompanionSelect=function(e){let t=this.navCompanion&&this.navCompanion.selectedCells;if(!t)return;let n=t[0],i=this.navCompanion.cells.indexOf(n),o=i+t.length-1,a=Math.floor((s=i,l=o,c=this.navCompanion.cellAlign,(l-s)*c+s));var s,l,c;if(this.selectCell(a,!1,e),this.removeNavSelectedElements(),a>=this.cells.length)return;let v=this.cells.slice(i,o+1);this.navSelectedElements=v.map(e=>e.element),this.changeNavSelectedClass("add")},n.changeNavSelectedClass=function(e){this.navSelectedElements.forEach(function(t){t.classList[e]("is-nav-selected")})},n.activateAsNavFor=function(){this.navCompanionSelect(!0)},n.removeNavSelectedElements=function(){this.navSelectedElements&&(this.changeNavSelectedClass("remove"),delete this.navSelectedElements)},n.onNavStaticClick=function(e,t,n,i){"number"==typeof i&&this.navCompanion.selectCell(i)},n.deactivateAsNavFor=function(){this.removeNavSelectedElements()},n.destroyAsNavFor=function(){this.navCompanion&&(this.navCompanion.off("select",this.onNavCompanionSelect),this.off("staticClick",this.onNavStaticClick),delete this.navCompanion)},e});
/*!
 * Flickity is-next/is-previous v3.0.0
 */
!function(e,i){"object"==typeof module&&module.exports?module.exports=i(require("flickity"),require("fizzy-ui-utils")):e.Flickity=i(e.Flickity,e.fizzyUIUtils)}(window,function(e,i){return e.create._createPrevNextCells=function(){this.on("select",this._setPrevNextCells)},e.prototype._setPrevNextCells=function(){function e(e,i,t){e&&e.getCellElements().forEach(function(e){e.classList[i](t)})}e(this.previousSlide,"remove","is-previous"),e(this.nextSlide,"remove","is-next");var i=fizzyUIUtils.modulo(this.selectedIndex-1,this.slides.length),t=fizzyUIUtils.modulo(this.selectedIndex+1,this.slides.length);this.previousSlide=this.slides[i],this.nextSlide=this.slides[t],e(this.previousSlide,"add","is-previous"),e(this.nextSlide,"add","is-next")},e});
/**
 * Flickity fade v2.0.0
 * Fade between Flickity slides
*/
!function(e,t){"object"==typeof module&&module.exports?module.exports=t(require("flickity"),require("fizzy-ui-utils")):t(e.Flickity,e.fizzyUIUtils)}("undefined"!=typeof window?window:this,function(e,n){let t=e.Slide;t.prototype.renderFadePosition=function(){},t.prototype.setOpacity=function(t){this.cells.forEach(e=>{e.element.style.opacity=t})},e.create.fade=function(){this.fadeIndex=this.selectedIndex,this.prevSelectedIndex=this.selectedIndex,this.on("select",this.onSelectFade),this.on("dragEnd",this.onDragEndFade),this.on("settle",this.onSettleFade),this.on("activate",this.onActivateFade),this.on("deactivate",this.onDeactivateFade)};let i=e.prototype,s=i.updateSlides;i.updateSlides=function(){s.apply(this,arguments),this.options.fade&&this.slides.forEach((e,t)=>{var i=e.target-e.x,s=e.cells[0].x;e.cells.forEach(e=>{var t=e.x-s-i;this._renderCellPosition(e,t)});t=t===this.selectedIndex?1:0;e.setOpacity(t)})},i.onSelectFade=function(){this.fadeIndex=Math.min(this.prevSelectedIndex,this.slides.length-1),this.prevSelectedIndex=this.selectedIndex},i.onSettleFade=function(){delete this.didDragEnd,this.options.fade&&(this.selectedSlide.setOpacity(1),this.slides[this.fadeIndex]&&this.fadeIndex!==this.selectedIndex&&this.slides[this.fadeIndex].setOpacity(0))},i.onDragEndFade=function(){this.didDragEnd=!0},i.onActivateFade=function(){this.options.fade&&this.element.classList.add("is-fade")},i.onDeactivateFade=function(){this.options.fade&&(this.element.classList.remove("is-fade"),this.slides.forEach(e=>{e.setOpacity("")}))};let d=i.positionSlider;i.positionSlider=function(){this.options.fade?(this.fadeSlides(),this.dispatchScrollEvent()):d.apply(this,arguments)};let a=i.positionSliderAtSelected;i.positionSliderAtSelected=function(){this.options.fade&&this.setTranslateX(0),a.apply(this,arguments)},i.fadeSlides=function(){if(!(this.slides.length<2)){var s=this.getFadeIndexes();let e=this.slides[s.a],t=this.slides[s.b];var d=this.wrapDifference(e.target,t.target),n=this.wrapDifference(e.target,-this.x);n/=d,e.setOpacity(1-n),t.setOpacity(n);let i=s.a;this.isDragging&&(i=.5<n?s.a:s.b),void 0!==this.fadeHideIndex&&this.fadeHideIndex!==i&&this.fadeHideIndex!==s.a&&this.fadeHideIndex!==s.b&&this.slides[this.fadeHideIndex].setOpacity(0),this.fadeHideIndex=i}},i.getFadeIndexes=function(){return this.isDragging||this.didDragEnd?this.options.wrapAround?this.getFadeDragWrapIndexes():this.getFadeDragLimitIndexes():{a:this.fadeIndex,b:this.selectedIndex}},i.getFadeDragWrapIndexes=function(){let e=this.slides.map(function(e,t){return this.getSlideDistance(-this.x,t)},this),t=e.map(function(e){return Math.abs(e)});var i=Math.min(...t),s=t.indexOf(i),d=e[s],i=this.slides.length,d=0<=d?1:-1;return{a:s,b:n.modulo(s+d,i)}},i.getFadeDragLimitIndexes=function(){let t=0;for(let e=0;e<this.slides.length-1;e++){var i=this.slides[e];if(-this.x<i.target)break;t=e}return{a:t,b:t+1}},i.wrapDifference=function(e,t){let i=t-e;if(!this.options.wrapAround)return i;t=i+this.slideableWidth,e=i-this.slideableWidth;return Math.abs(t)<Math.abs(i)&&(i=t),Math.abs(e)<Math.abs(i)&&(i=e),i};let h=i._updateWrapShiftCells;i._updateWrapShiftCells=function(){this.options.fade?this.isWrapping=this.getIsWrapping():h.apply(this,arguments)};let l=i.shiftWrapCells;return i.shiftWrapCells=function(){this.options.fade||l.apply(this,arguments)},e});


// global.js
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// global.js
/*
@license
  Be Yours by roartheme (https://roartheme.co)
  Access unminified JS in assets/global.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/beyours/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
window.theme = window.theme || {}

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  rtl: document.documentElement.getAttribute('dir') === 'rtl' ? true : false,
}

theme.Currency = (function () {
  const moneyFormat = '${{amount}}' // eslint-disable-line camelcase

  function formatMoney (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }
    let value = ''
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    const formatString = format || moneyFormat

    function formatWithDelimiters (number, precision, thousands, decimal) {
      thousands = thousands || ','
      decimal = decimal || '.'

      if (isNaN(number) || number === null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      const parts = number.split('.')
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands,
      )
      const centsAmount = parts[1] ? decimal + parts[1] : ''

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ')
        break
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, '\'')
        break
    }

    return formatString.replace(placeholderRegex, value)
  }

  function getBaseUnit (variant) {
    if (!variant) {
      return
    }

    if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
      return
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
      variant.unit_price_measurement.reference_unit
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit,
  }
})()

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback()
          observer.unobserve(entry.target)
        }
      }
    })
  }, { rootMargin: `0px 0px ${threshold}px 0px` })

  observer.observe(options.element)
};

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall)
  theme.config.mqlSmall = mql.matches
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true
      document.dispatchEvent(new CustomEvent('matchSmall'))
    } else {
      theme.config.mqlSmall = false
      document.dispatchEvent(new CustomEvent('unmatchSmall'))
    }
  }

  // Page transition
  window.addEventListener('beforeunload', () => {
    document.body.classList.add('unloading')
  })
  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('loaded')

    document.dispatchEvent(new CustomEvent('page:loaded'))
  })
  window.addEventListener('pageshow', (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove('unloading')
    }
  })

  // Viewport height
  function viewportHeight () {
    if (window.matchMedia('(max-width: 990px)')) {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
    }

    setHeaderBottomPosition()
  }

  window.addEventListener('resize', viewportHeight)
  window.addEventListener('DOMContentLoaded', viewportHeight)

  if (document.body.getAttribute('data-page-rendering') !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap && el.attributeStyleMap.set('content-visibility', 'visible')
            el.markedVisible = true
          }
        })
      },
      // Set a rendering 50px above and 100px below the main scroll area.
      { rootMargin: '50px 0px 100px 0px' },
    )
    const sections = document.querySelectorAll('.shopify-section + .shopify-section')
    sections.forEach((section) => { observer.observe(section) })
  }

  /*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})();

// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1
  var t

  document.body.addEventListener('touchstart', function (i) {
    if (!i.target.closest('.flickity-slider')) {
      return e = !1
    }
    e = !0
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY,
    }
  })

  document.body.addEventListener('touchmove', function (i) {
    if (e && i.cancelable) {
      var n = {
        x: i.touches[0].pageX - t.x,
        y: i.touches[0].pageY - t.y,
      }
      Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
    }
  }, { passive: !1 })
})()

function isStorageSupported (type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false
  }

  const testKey = 'beyours:test'
  let storage
  if (type === 'session') {
    storage = window.sessionStorage
  }
  if (type === 'local') {
    storage = window.localStorage
  }

  try {
    storage.setItem(testKey, '1')
    storage.removeItem(testKey)
    return true
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false
  }
}

function checkScrollbar () {
  const rect = document.body.getBoundingClientRect()
  return Math.round(rect.left + rect.right) < window.innerWidth
}

function setScrollbarWidth () {
  if (checkScrollbar()) {
    const element = document.createElement('span')
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element)

    const width = element.getBoundingClientRect().width - element.clientWidth
    document.body.removeChild(element)
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`)
  }
}

function setHeaderBottomPosition () {
  const header = document.querySelector('.shopify-section-header')
  if (header) {
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`)
  }
}

function getFocusableElements (container) {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:enabled, [tabindex]:not([tabindex^=\'-\']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe',
    ),
  )
}

const trapFocusHandlers = {}

function trapFocus (container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase()
    if (charCode !== 'TAB') return // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  if (elementToFocus) elementToFocus.focus()

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill () {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused')

    if (mouseClick) return

    currentFocusedElement = document.activeElement
    currentFocusedElement.classList.add('focused')

  }, true)
}

function pauseAllMedia () {
  document.querySelectorAll('video-section[data-type="youtube"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('video-section[data-type="vimeo"]:not([data-video-hero]) iframe').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => {
    if (!video.closest('[data-video-hero]')) video.pause()
  })
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus (elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape (event) {
  const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase()
  if (charCode !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

function filterShopifyEvent (event, domElement, callback) {
  let executeCallback = false
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true
    }
  } else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true
  }
  if (executeCallback) {
    callback(event)
  }
}

function debounce (fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig (type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` },
  }
}

const serializeForm = form => {
  const obj = {}
  const formData = new FormData(form)

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/

    if (regex.test(key)) {
      obj.properties = obj.properties || {}
      obj.properties[regex.exec(key)[2]] = formData.get(key)
    } else {
      obj[key] = formData.get(key)
    }
  }

  return JSON.stringify(obj)
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  const method = options['method'] || 'post'
  const params = options['parameters'] || {}

  const form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (const key in params) {
    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.postLink2 = function (path, options) {
  options = options || {}
  const method = options['method'] || 'post'
  const params = options['parameters'] || {}

  const form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement('input')
        hiddenField.setAttribute('type', 'hidden')
        hiddenField.setAttribute('name', `${key}[${index}][${key2}]`)
        hiddenField.setAttribute('value', params[key][index][key2])
        form.appendChild(hiddenField)
      }
    }
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class QuantityInput extends HTMLElement {
  constructor () {
    super()

    this.init()
  }

  init () {
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this)),
    )

    this.input.addEventListener('focus', this.onInputFocus.bind(this))
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }

  onInputFocus () {
    this.input.select()
  }
}

customElements.define('quantity-input', QuantityInput)

class DrawerCloseButton extends HTMLElement {
  constructor () {
    super()

    this.addEventListener('click', () => this.dispatchEvent(new CustomEvent('drawer:force-close', { bubbles: true, cancelable: true, composed: true })))
  }
}

customElements.define('drawer-close-button', DrawerCloseButton)

class MenuDrawer extends HTMLElement {
  constructor () {
    super()

    this.classes = {
      open: 'menu-drawer--open',
      opening: 'menu-drawer--opening',
      closing: 'menu-drawer--closing',
    }

    this.mainDetailsToggle = this.querySelector('details')

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  setClasses (classes) {
    this.classes = classes
  }

  bindEvents () {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)))
    this.querySelectorAll('button[data-close]').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)))

    this.addEventListener('drawer:force-close', (event) => {
      event.stopPropagation()
      this.closeMenuDrawer(event)
    })
  }

  onKeyUp (event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase()
    if (charCode !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick (event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus () {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus)
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus)
      }, 100)
    }
  }

  openMenuDrawer (summaryElement = false) {
    setScrollbarWidth()
    setHeaderBottomPosition()

    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', true)
      trapFocus(this.mainDetailsToggle, summaryElement)
    }

    setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
      document.body.addEventListener('click', this.onBodyClickEvent)
    })
    document.body.classList.add(this.classes.opening)

    this.openAnimation()
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '')
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening')
      }, 10)
    })
  }

  closeMenuDrawer (event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.classList.add('menu-closing')
      removeTrapFocus(elementToFocus)

      document.body.removeEventListener('click', this.onBodyClickEvent)
      document.body.classList.remove(this.classes.open)
      document.body.classList.add(this.classes.closing)

      this.closeAnimation(this.mainDetailsToggle)
      this.dispatchEvent(new CustomEvent('close'))
      document.dispatchEvent(new CustomEvent('menudrawer:close'))
    }
  }

  onFocusOut () {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer()
    })
  }

  onCloseButtonClick (event) {
    const target = event.currentTarget
    if (target.classList.contains('noclose')) return

    const detailsElement = target.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu (detailsElement) {
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    removeTrapFocus()
    this.closeAnimation(detailsElement)
  }

  openAnimation () {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        document.body.classList.remove(this.classes.opening)
        document.body.classList.add(this.classes.open)
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }

  closeAnimation (detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing)
          detailsElement.classList.remove('menu-closing')
        }
        detailsElement.removeAttribute('open')

        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }

  onBodyClick (event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class CartDrawer extends MenuDrawer {
  constructor () {
    super()

    this.setClasses({
      open: 'mini-cart--open',
      opening: 'mini-cart--opening',
      closing: 'mini-cart--closing',
    })
  }
}

customElements.define('cart-drawer', CartDrawer)

class FacetDrawer extends MenuDrawer {
  constructor () {
    super()

    if (this.dataset.desktop == 'true') {
      this.setClasses({
        open: 'facet-horizontal--open',
        opening: 'facet-horizontal--opening',
        closing: 'facet-horizontal--closing',
      })
    } else {
      this.setClasses({
        open: 'facet-drawer--open',
        opening: 'facet-drawer--opening',
        closing: 'facet-drawer--closing',
      })
    }
  }
}

customElements.define('facet-drawer', FacetDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor () {
    super()

    this.setClasses({
      open: 'menu-mobile--open',
      opening: 'menu-mobile--opening',
      closing: 'menu-mobile--closing',
    })
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor () {
    super()

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this),
    )
    this.addEventListener('keyup', (event) => {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase()
      if (charCode === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
      })
    }
  }

  show (opener) {
    setScrollbarWidth()
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide () {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor () {
    super()

    this.button = this.querySelector('button')
    if (!this.button) return

    this.button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(this.button)
    })
  }
}

customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor () {
    super()

    this.poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!this.poster) return

    this.poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent (focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      if (content.querySelector('video-section')) {
        const deferredElement = this.appendChild(content)
        if (focus) deferredElement.focus()
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play()
        }
      } else {
        this.setAttribute('loaded', true)
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'))
        if (focus) deferredElement.focus()
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play()
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor () {
    super()

    this.slider = this.querySelector('[id^="Slider-"]')
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.enableSliderLooping = false
    this.currentPageElement = this.querySelector('.slider-counter--current')
    this.pageTotalElement = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    })
  }

  init () {
    const resizeObserver = new ResizeObserver(() => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener('scroll', this.update.bind(this))
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
  }

  initPages () {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0)
    if (this.sliderItemsToShow.length < 2) return
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset)
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
    this.update()
  }

  resetPages () {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.initPages()
  }

  update () {
    const previousPage = this.currentPage
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage
      this.pageTotalElement.textContent = this.totalPages
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      }))
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add('slider--no-buttons')
    } else {
      this.classList.remove('slider--no-buttons')
    }

    if (this.enableSliderLooping) return

    const isFirstSlide = this.currentPage === 1
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length

    if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled')
    } else {
      this.prevButton.removeAttribute('disabled')
    }

    if (isLastSlide || this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled')
    } else {
      this.nextButton.removeAttribute('disabled')
    }
  }

  isSlideVisible (element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
  }

  onButtonClick (event) {
    event.preventDefault()

    const step = event.currentTarget.dataset.step || 1
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset)
    this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }
}

customElements.define('slider-component', SliderComponent)

class ThumbnailSlider extends SliderComponent {
  constructor () {
    super()
  }

  init () {
    super.init()

    const variantItems = this.querySelectorAll('.thumbnail-list_item--variant:not(.is-active)')
    this.slider.dataset.mediaCount = this.sliderItems.length - variantItems.length

    if (this.querySelector('[data-gang-option]')) {
      const inactiveGangItems = this.querySelectorAll('[data-gang-option]:not(.gang__active)')
      this.slider.dataset.mediaCount = this.sliderItems.length - inactiveGangItems.length
    }

    if (this.slider.dataset.mediaCount < 2) this.classList.add('hidden')
  }
}

customElements.define('thumbnail-slider', ThumbnailSlider)

class QuoteSlider extends SliderComponent {
  constructor () {
    super()
  }

  update () {
    super.update()

    if (this.currentPageElement && this.pageTotalElement) {
      this.sliderItems.forEach((element) => {
        element.removeAttribute('aria-current')
      })

      const currentElement = this.sliderItemsToShow[this.currentPage - 1]
      currentElement.setAttribute('aria-current', true)
    }
  }
}

customElements.define('quote-slider', QuoteSlider)

class ProductGallery extends SliderComponent {
  constructor () {
    super()
  }

  init () {
    super.init()

    const gallerySliderButtons = this.querySelector('.slider-buttons')
    if (gallerySliderButtons && this.querySelector('[data-gang-option]')) {
      if (this.querySelectorAll('.product__media-item.gang__active').length < 2) {
        gallerySliderButtons.classList.add('hidden')
      } else {
        gallerySliderButtons.classList.remove('hidden')
      }
    }

    this.cursor = this.querySelector('.gallery-cursor')
    if (!this.cursor) return

    const images = this.querySelectorAll('.product__modal-opener--image')
    images.forEach((image) => image.addEventListener('mousemove', this.onMoveHandler.bind(this)))
    images.forEach((image) => image.addEventListener('mouseenter', this.onEnterHandler.bind(this)))
    images.forEach((image) => image.addEventListener('mouseleave', this.onLeaveHandler.bind(this)))
  }

  onMoveHandler (event) {
    this.cursor.style.left = `${event.clientX - 32}px`
    this.cursor.style.top = `${event.clientY - 32}px`
  }

  onEnterHandler () {
    this.cursor.classList.add('show')
  }

  onLeaveHandler () {
    this.cursor.classList.remove('show')
  }

  update () {
    super.update()

    if (this.currentPageElement && this.pageTotalElement) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1]
      if (currentElement) {
        this.slider.style.setProperty('--force-image-ratio-percent', currentElement.querySelector('.media').style.getPropertyValue('--image-ratio-percent'))
      }
    }
  }

  goToFirstSlide () {
    this.slider.scrollTo({
      left: 0,
    })
  }
}

customElements.define('product-gallery', ProductGallery)

class VariantSelects extends HTMLElement {
  constructor () {
    super()

    this.addEventListener('change', this.onVariantChange)
    this.addEventListener('changeFromSelect', this.changeFromSelect)

    this.updateOptions()
    this.updateMasterId()
    this.setAvailability()
  }

  changeFromSelect () {
    this.updateOptions()
    this.updateMasterId()
    this.setAvailability()
  }

  onVariantChange (event) {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.validateGang()
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
      this.setAvailabilityInUnavailable()
    } else {
      if (this.gangOption) {
        this.updateGangMedia()
      } else {
        this.updateMedia()
      }
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.setAvailability()

      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant,
        },
      }))
    }

    this.handleStickyCart(event.target)
  }

  handleStickyCart (target) {
    const stickyCart = document.getElementById(`sticky-cart-${this.dataset.section}`)
    if (!stickyCart) return

    const attribute = target.getAttribute('name')

    document.querySelectorAll(`variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`).
      forEach((input) => {
        if (input.tagName === 'INPUT') {
          input.checked = input.value === target.value
        } else {
          input.value = target.value
        }
      })

    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const image = document.querySelector('.sticky-cart__content-image img')
    if (image) {
      image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`
      image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`
      image.width = 70
      image.height = Math.ceil(70 / this.currentVariant.featured_media.preview_image.aspect_ratio)
    }
  }

  updateOptions () {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
    document.querySelector('variant-radios').querySelector(`input[value="${this.options.join()}"]`).checked=true
    console.log("This", this.options.join())

  }

  updateMasterId () {
    this.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option
      }).includes(false)
    })
  }

  validateGang () {
    const mediaItemWithGang = document.querySelector(`#shopify-section-${this.dataset.section} [data-gang-option], quick-view-drawer details[open] [data-gang-option]`)
    if (mediaItemWithGang) {
      this.gangOption = mediaItemWithGang.dataset.gangOption
    }
  }

  updateGangMedia () {
    if (!this.gangOption) return

    const variantInputWrapper = this.querySelector('.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]')
    if (variantInputWrapper) {
      this.gangIndex = variantInputWrapper.dataset.optionIndex
    } else {
      this.gangOption = null
    }

    if (!this.currentVariant) return
    //if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`)
    const gangValue = this.getSlug(this.currentVariant[this.gangIndex])
    if (this.currentGangValue !== gangValue) {
      document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect], quick-view-drawer details[open] [data-gang-connect]`,
      ).forEach(function (media) {
        media.classList.remove('gang__active')
      })

      this.currentGangValue = gangValue
      var gangConnect = this.gangOption + '_' + gangValue
      const newMedias = document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"], quick-view-drawer details[open] [data-gang-connect="${gangConnect}"]`,
      )

      if (!newMedias.length) return
      Array.from(newMedias).reverse().forEach(function (newMedia) {
        newMedia.classList.add('gang__active')
        let parent = newMedia.parentElement
        if (parent.firstChild != newMedia) {
          parent.prepend(newMedia)
          parent.classList.add('product__media-no-animate')
        }
      })

      const thumbnailSlider = document.getElementById(`GalleryThumbnails-${this.dataset.section}`)
      if (thumbnailSlider) {
        const inactiveItems = thumbnailSlider.querySelectorAll('.thumbnail-list__item:not(.gang__active)')
        thumbnailSlider.slider.dataset.mediaCount = thumbnailSlider.sliderItems.length - inactiveItems.length
        if (thumbnailSlider.slider.dataset.mediaCount < 2) {
          thumbnailSlider.classList.add('hidden')
        } else {
          thumbnailSlider.classList.remove('hidden')
        }
        thumbnailSlider.resetPages()
      }

      if (!mediaGallery) {
        const productGallery = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery, quick-view-drawer details[open] product-gallery`)
        if (productGallery) {
          productGallery.resetPages()
          productGallery.goToFirstSlide()
        }
      }

      const gallerySliderButtons = document.querySelector(`#shopify-section-${this.dataset.section} product-gallery .slider-buttons, quick-view-drawer details[open] product-gallery .slider-buttons`)
      if (gallerySliderButtons) {
        if (document.querySelectorAll(
          `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).length < 2) {
          gallerySliderButtons.classList.add('hidden')
        } else {
          gallerySliderButtons.classList.remove('hidden')
        }
      }
    }

    if (!this.currentVariant.featured_media) {
      if (!document.querySelectorAll(
        `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active.is-active`).length) {
        document.querySelector(
          `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`).
          classList.
          add('is-active')
      }
      return
    }

    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined'
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView)
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`)
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
      modalContent.prepend(newMediaModal)
    }

    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`)
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
      thumbnailContent.prepend(newMediaThumbnail)
    }
  }

  CJKDetect (someString) {
    // Korean
    if (someString.search('[\uac00-\ud7a3]') >= 0) return 'ko'
    // Japanese
    if (someString.search('[\u3040-\u30ff]') >= 0) return 'ja'
    // Chinese
    if (someString.search('[\u4e00-\u9FFF]') >= 0) return 'zh'

    return 'none'
  }

  getSlug (someString) {
    if (this.CJKDetect(someString) != 'none') return someString
    return someString.toString().replace('ı', 'i').normalize('NFD').replace('-', ' ').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '-')
  }

  updateMedia () {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    )

    if (!newMedia) return

    const parent = newMedia.parentElement
    if (parent.firstChild == newMedia) return
    parent.prepend(newMedia)
    parent.classList.add('product__media-no-animate')

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`)
    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === 'undefined'
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true, scrollIntoView)
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`)
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
      modalContent.prepend(newMediaModal)
    }

    const thumbnailContent = document.querySelector(`#ProductThumbnails-${this.dataset.section}`)
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
      thumbnailContent.prepend(newMediaThumbnail)
    }
  }

  updateURL () {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}--alt`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability () {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage () {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo () {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then((response) => response.text()).then((responseText) => {
      this.updateSKU(responseText)
      this.updatePrice(responseText)
      this.updatePriceAlt(responseText)
      this.updateColorName(responseText)
      this.updateInventoryStatus(responseText)
      if (this.currentVariant) this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
      this.updateCustomLiquid(responseText)

      document.dispatchEvent(new CustomEvent('productInfo:loaded'))

      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId,
          variant: this.currentVariant,
        },
      })
    }).catch((e) => {
      console.error(e)
    })
  }

  updateSKU (responseText) {
    const id = `sku-${this.dataset.section}`
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.getElementById(id)
    const source = html.getElementById(id)

    if (source && destination) destination.innerHTML = source.innerHTML
    if (destination) destination.classList.remove('visibility-hidden')
  }

  updateCustomLiquid (responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destinations = document.querySelectorAll(`.custom__liquid-${this.dataset.section}`)
    const sources = html.querySelectorAll(`.custom__liquid-${this.dataset.section}`)

    for (let i = 0, clLength = destinations.length; i < clLength; i++) {
      destinations[i].innerHTML = sources[i].innerHTML
    }
  }

  updatePrice (responseText) {
    const id = `price-${this.dataset.section}`
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.getElementById(id)
    const source = html.getElementById(id)

    if (source && destination) destination.innerHTML = source.innerHTML
    if (destination) destination.classList.remove('visibility-hidden')
  }

  updatePriceAlt (responseText) {
    const id = `price-${this.dataset.section}--alt`
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.getElementById(id)
    const source = html.getElementById(id)

    if (source && destination) destination.innerHTML = source.innerHTML
    if (destination) destination.classList.remove('visibility-hidden')
  }

  updateColorName (responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html')

    for (let index = 1; index <= 3; index++) {
      const id = index > 1 ? `color-${this.dataset.section}-${index}` : `color-${this.dataset.section}`
      const destination = document.getElementById(id)
      const source = html.getElementById(id)

      if (source && destination) destination.innerHTML = source.innerHTML
      if (destination) destination.classList.remove('visibility-hidden')
    }
  }

  updateInventoryStatus (responseText) {
    const id = `inventory-${this.dataset.section}`
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.getElementById(id)
    const source = html.getElementById(id)

    if (source && destination) destination.innerHTML = source.innerHTML
    if (destination) destination.classList.remove('visibility-hidden')
  }

  toggleAddButton (disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`)
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]')
      if (!addButton) return

      if (disable) {
        addButton.setAttribute('disabled', true)
        if (text) addButton.textContent = text
      } else {
        addButton.removeAttribute('disabled')
        addButton.textContent = addButton.dataset.preOrder === 'true' ? window.variantStrings.preOrder : window.variantStrings.addToCart
      }

      if (!modifyClass) return
    })
  }

  setUnavailable () {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`)
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]')
      if (!addButton) return
      addButton.textContent = window.variantStrings.unavailable

      const price = document.getElementById(`price-${this.dataset.section}`)
      if (price) price.classList.add('visibility-hidden')

      const priceAlt = document.getElementById(`price-${this.dataset.section}--alt`)
      if (priceAlt) priceAlt.classList.add('visibility-hidden')

      const inventory = document.getElementById(`inventory-${this.dataset.section}`)
      if (inventory) inventory.classList.add('visibility-hidden')
    })
  }

  getVariantData () {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  setAvailability () {
    if (!this.currentVariant) return

    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group)
    })

    const currentlySelectedValues = this.currentVariant.options.map((value, index) => {return { value, index: `option${index + 1}` }})
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant)

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values)
    }
  }

  setAvailabilityInUnavailable () {
    this.querySelectorAll('.variant-input-wrapper').forEach(group => {
      this.disableVariantGroup(group)
    })

    const currentlySelectedValues = this.options.map((value, index) => {return { value, index: `option${index + 1}` }})
    const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant)

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values)
    }
  }

  enableVariantOption (group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1')
    group.querySelector('option[value="' + value + '"]').disabled = false
  }

  disableVariantGroup (group) {
    group.querySelectorAll('option').forEach((option) => {
      option.disabled = true
    })
  }

  manageOptionState (option, values) {
    const group = this.querySelector('.variant-input-wrapper[data-option-index="' + option + '"]')

    // Loop through each option value
    values.forEach(obj => {
      this.enableVariantOption(group, obj)
    })
  }

  createAvailableOptionsTree (variants, currentlySelectedValues) {
    // Reduce variant array into option availability tree
    return variants.reduce((options, variant) => {

      // Check each option group (e.g. option1, option2, option3) of the variant
      Object.keys(options).forEach(index => {

        if (variant[index] === null) return

        let entry = options[index].find(option => option.value === variant[index])

        if (typeof entry === 'undefined') {
          // If option has yet to be added to the options tree, add it
          entry = { value: variant[index], soldOut: true }
          options[index].push(entry)
        }

        const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1')
        const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2')

        switch (index) {
          case 'option1':
            // Option1 inputs should always remain enabled based on all available variants
            entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut
            break
          case 'option2':
            // Option2 inputs should remain enabled based on available variants that match first option group
            if (currentOption1 && variant['option1'] === currentOption1.value) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut
            }
          case 'option3':
            // Option 3 inputs should remain enabled based on available variants that match first and second option group
            if (
              currentOption1 && variant['option1'] === currentOption1.value
              && currentOption2 && variant['option2'] === currentOption2.value
            ) {
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut
            }
        }
      })

      return options
    }, { option1: [], option2: [], option3: [] })
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {

  constructor () {
    super()
  }

  updateOptions () {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    })
    let event = new Event('changeFromSelect')
    document.querySelector('variant-selects').querySelector('select').value=this.options.join()
    document.querySelector('variant-selects').dispatchEvent(event)
  }

  enableVariantOption (group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1')
    const input = group.querySelector('input[data-option-value="' + value + '"]')

    // Variant exists - enable & show variant
    input.removeAttribute('disabled')
    input.removeAttribute('data-crossout')

    // Variant sold out - cross out option (remains selectable)
    if (obj.soldOut) {
      if (this.hasAttribute('data-swatch-cross')) {
        if (this.hasAttribute('data-swatch-oos-click')) {
          input.setAttribute('data-crossout', '')
        } else {
          input.setAttribute('disabled', '')
        }
      }
    }
  }

  disableVariantGroup (group) {
    group.querySelectorAll('input').forEach((input) => {
      input.setAttribute('disabled', '')
    })
  }
}

customElements.define('variant-radios', VariantRadios)

class ProductForm extends HTMLElement {
  constructor () {
    super()

    this.miniCart = document.querySelector('mini-cart')
    this.form = this.querySelector('form')
    this.form.querySelector('[name=id]').disabled = false
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    this.hideErrors = this.dataset.hideErrors === 'true'
  }

  onSubmitHandler (evt) {
    if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
      return
    }

    evt.preventDefault()
    const submitButton = this.querySelector('[type="submit"]')
    if (submitButton.classList.contains('loading')) {
      return
    }

    this.handleErrorMessage()

    submitButton.setAttribute('aria-disabled', true)
    submitButton.classList.add('loading')

    const config = fetchConfig('javascript')
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    delete config.headers['Content-Type']

    const formData = new FormData(this.form)

    if (this.miniCart) {
      formData.append('sections', this.miniCart.getSectionsToRender().map((section) => section.id))
    }
    formData.append('sections_url', window.location.pathname)
    config.body = formData

    fetch(`${window.routes.cart_add_url}`, config).then((response) => response.json()).then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        })
        this.handleErrorMessage(response.description)
        this.error = true
        return
      }

      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') })
      this.error = false

      if (this.miniCart) {
        this.miniCart.renderContents(response)
      }
    }).catch((e) => {
      console.error(e)
    }).finally(() => {
      submitButton.classList.remove('loading')
      submitButton.removeAttribute('aria-disabled')
    })
  }

  handleErrorMessage (errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')

    if (this.errorMessageWrapper) {
      if (this.hideErrors) return
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    } else {
      if (errorMessage) {
        alert(errorMessage)
      }
    }
  }
}

customElements.define('product-form', ProductForm)

class ProgressBar extends HTMLElement {
  constructor () {
    super()

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    })
  }

  init () {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity)
      this.style.setProperty('--progress-bar-width', `${quantity * 100 / 30}%`)
    }, 1e3)
  }
}

customElements.define('progress-bar', ProgressBar)

class FormState extends HTMLElement {
  constructor () {
    super()

    this.formInputs = this.querySelectorAll('input,select,textarea')
    this.form = this.querySelector('form')

    this.formInputs.forEach((input) => {
      input.addEventListener('input', this.onInputChange.bind(this))
      input.addEventListener('blur', this.onInputChange.bind(this))
    })

    if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
  }

  onInputChange (event) {
    this.handleInputCheck(event.target)
  }

  onSubmitHandler (event) {
    let valid = !0

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1
      }
    })

    if (!valid) {
      event.preventDefault()
      return
    }
  }

  handleInputCheck (input) {
    if (input.classList.contains('required')) {

      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove('valid')
        input.classList.add('invalid')

        return !1
      } else {
        input.classList.remove('invalid')
        input.classList.add('valid')

        return !0
      }
    }

    return !0
  }
}

customElements.define('form-state', FormState)

class ListMenuItem extends HTMLElement {
  constructor () {
    super()

    this.listMenuHover = this.closest('menu-drawer').querySelector('list-menu-hover')

    this.addEventListener('mouseenter', () => {
      this.listMenuHover.open({
        title: this.dataset.title,
        url: this.dataset.url,
        image: this.dataset.image,
        description: this.dataset.description,
      })
    })
  }
}

customElements.define('list-menu-item', ListMenuItem)

class ListMenuHover extends HTMLElement {
  constructor () {
    super()
  }

  open (obj) {
    let html = ''
    const opened = obj.image.length > 0 || obj.description.length > 0

    if (opened) {
      html += `<a href="${obj.url}" class="hover-collection${obj.image.length > 0 ? '' : ' hover-collection--no-image'}">`
      html += '<figure class="hover-collection__image"' + (obj.image.length > 0 ? `style="background-image:url(${obj.image})"` : '') + '></figure>'
      html += '<div class="hover-collection__content">'
      html += `<span class="hover-collection__title h4">${obj.title}</span>`
      html += obj.description.length > 0 ? `<div class="hover-collection__description">${obj.description}</div>` : ''
      html += '</div>'
      html += '</a>'
    }

    this.innerHTML = html
  }

  close () {
    this.innerHTML = ''
  }
}

customElements.define('list-menu-hover', ListMenuHover)

class TransparentHeader extends HTMLElement {
  constructor () {
    super()

    const header = document.querySelector('.shopify-section-header')

    header.classList.add('transparent-header')
    if (this.dataset.showSeparator == 'true') {
      header.classList.add('transparent-separator')
    }
  }
}

customElements.define('transparent-header', TransparentHeader)

class AddToCart extends HTMLElement {
  constructor () {
    super()

    this.miniCart = document.querySelector('mini-cart')
    this.addEventListener('click', this.onClickHandler.bind(this))
  }

  onClickHandler () {
    const variantId = this.dataset.variantId

    if (variantId) {
      if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
        Shopify.postLink(window.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        })
        return
      }

      this.setAttribute('disabled', true)
      this.classList.add('loading')
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : []

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      })

      fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body }).then((response) => response.json()).then((parsedState) => {
        if (parsedState.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: parsedState.description,
            },
          }))
        } else {
          this.miniCart && this.miniCart.renderContents(parsedState)

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: parsedState,
            },
          }))
        }
      }).catch((e) => {
        console.error(e)
      }).finally(() => {
        this.classList.remove('loading')
        this.removeAttribute('disabled')
      })
    }
  }
}

customElements.define('add-to-cart', AddToCart)

class PriceMoney extends HTMLElement {
  constructor () {
    super()

    if (this.shouldInit()) {
      this.init()
    }
  }

  shouldInit () {
    if (document.body.dataset.priceSuperscript === undefined) {
      return false
    }

    const moneyFormat = window.shopSettings.moneyFormat.toLowerCase()
    if (moneyFormat.indexOf('class=') !== -1) {
      return false
    }

    return true
  }

  init () {
    const currencies_using_comma_decimals = 'ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND'.split(',')
    const symbol = window.shopSettings.moneyFormat.replace(/\{{.*}}/, '').trim()
    const bdi = this.querySelector('bdi')
    const price = bdi.textContent.replace(window.shopSettings.isoCode, '')
    let html = price.replace(' ', '')
    let money_symbol_decimal = '.'
    if (currencies_using_comma_decimals.includes(window.shopSettings.isoCode)) {
      money_symbol_decimal = ','
    }
    if (price.includes(money_symbol_decimal)) {
      if (price.lastIndexOf(symbol) + symbol.length === price.length) {
        const price_without_symbol = price.slice(0, price.lastIndexOf(symbol))
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal))
        const decimal = price_without_symbol.replace(price_without_decimal, '').trim()
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`)
      } else {
        const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal))
        const decimal = price.replace(price_without_decimal, '').trim()
        html = html.replace(decimal, `<sup class="price__suffix">${decimal}</sup>`)
      }
    }
    html = html.replace(symbol, `<span class="price__prefix">${symbol}</span>`)
    if (window.shopSettings.currencyCode) {
      html = html + ' ' + window.shopSettings.isoCode
    }
    bdi.innerHTML = html
  }
}

customElements.define('price-money', PriceMoney)

class SlideshowComponent extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      small: this.querySelector('.slideshow__left'),
      content: this.querySelector('.slideshow__content'),
      large: this.querySelector('.slideshow__right'),
    }
    this.settings = {
      autorotate: this.dataset.autorotate == 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll('.slideshow__image'),
      slidesLarge: this.elements.large.querySelectorAll('.slideshow__image'),
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    })
    this.matchMedia()
  }

  init () {
    setTimeout(() => {
      this.flickitySmall = new Flickity(this.elements.small, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: false,
        setGallerySize: false,
        autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
      })

      this.flickityContent = new Flickity(this.elements.content, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: theme.config.mqlSmall ? true : false,
        asNavFor: this.elements.small,
        adaptiveHeight: true,
        arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll('.flickity-button')
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute('tabindex', '-1')
              })
            }
          },
        },
      })

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content,
        dragThreshold: 10,
      })

      this.bindEvents()
    })
  }

  bindEvents () {
    this.flickitySmall.on('scroll', () => {
      this.flickitySmall.slides.forEach((slide, i) => {
        const flickity = this.flickitySmall
        const image = this.settings.slidesSmall[i]
        let x = 0

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth ? (flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target) : (slide.target + flickity.x)
          } else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth ? (slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth) : (slide.target +
              flickity.x)
          } else {
            x = slide.target + flickity.x
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * (-1 / 2) + 'px)'
          }
        }
      })
    })

    this.flickityLarge.on('scroll', () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge
        const image = this.settings.slidesLarge[i]
        let x = 0

        if (image) {
          if (0 === i) {
            x = Math.abs(flickity.x) > flickity.slidesWidth ? (flickity.slidesWidth + flickity.x + flickity.slides[flickity.slides.length - 1].outerWidth + slide.target) : (slide.target + flickity.x)
          } else if (i === flickity.slides.length - 1) {
            x = Math.abs(flickity.x) + flickity.slides[i].outerWidth < flickity.slidesWidth ? (slide.target - flickity.slidesWidth + flickity.x - flickity.slides[i].outerWidth) : (slide.target +
              flickity.x)
          } else {
            x = slide.target + flickity.x
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = 'translateX(' + x * (-1 / 2) + 'px)'
          }
        }
      })
    })

    this.elements.content.querySelector('.flickity-button.next').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.next()
      this.stopPlayer()
    })

    this.elements.content.querySelector('.flickity-button.previous').addEventListener('click', () => {
      this.flickitySmall && this.flickitySmall.previous()
      this.stopPlayer()
    })

    this.elements.content.querySelectorAll('.flickity-page-dot').forEach((button) => {
      button.addEventListener('click', () => {
        this.stopPlayer()
      })
    })

    let currentIndex = null,
      swipeDirection = null

    // Detect swipe direction
    this.flickityLarge.on('dragMove', (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex
      swipeDirection = this.getSwipeDirection(moveVector)

      this.stopPlayer()
    })

    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on('dragEnd', () => {
      if (this.flickityLarge.selectedIndex !== currentIndex) {

        if (swipeDirection === 'left') {
          this.flickitySmall.next()
        } else {
          this.flickitySmall.previous()
        }
      }
    })
  }

  stopPlayer () {
    if (this.settings.autorotate) {
      this.flickitySmall && this.flickitySmall.stopPlayer()
    }
  }

  getSwipeDirection (moveVector) {
    return moveVector.x > 0 ? 'right' : 'left'
  }

  matchMedia () {
    document.addEventListener('matchSmall', () => {
      this.unload()
      this.init()
    })

    document.addEventListener('unmatchSmall', () => {
      this.unload()
      this.init()
    })
  }

  unload () {
    if (this.flickitySmall && typeof this.flickitySmall.destroy === 'function') {
      this.flickitySmall.destroy()
    }
    if (this.flickityContent && typeof this.flickityContent.destroy === 'function') {
      this.flickityContent.destroy()
    }
    if (this.flickityLarge && typeof this.flickityLarge.destroy === 'function') {
      this.flickityLarge.destroy()
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent)

class TestimonialsComponent extends HTMLElement {
  constructor () {
    super()

    if (this.dataset.slider == 'true') {
      this.settings = {
        autorotate: this.dataset.autorotate == 'true',
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      }
      this.slider = this.querySelector('.testimonial__list')
      this.previews = this.querySelector('.testimonial__previews')

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600,
      })
      theme.initWhenVisible({
        element: this,
        callback: this.update.bind(this),
        threshold: 0,
      })
    }
  }

  init () {
    setTimeout(() => {
      if (this.slider) {
        this.flickity = new Flickity(this.slider, {
          accessibility: false,
          rightToLeft: theme.config.rtl,
          prevNextButtons: true,
          arrowShape: 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
          pageDots: false,
          wrapAround: true,
          draggable: true,
          cellAlign: 'center',
          autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
          pauseAutoPlayOnHover: true,
          asNavFor: this.previews,
        })
      }

      this.flickityNav = new Flickity(this.previews, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: this.flickity ? false : true,
        arrowShape: this.flickity
          ? ''
          : 'M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z',
        pageDots: false,
        wrapAround: true,
        selectedAttraction: 0.2,
        friction: 0.8,
        adaptiveHeight: true,
      })

      this.flickityNav.previous()
      if (this.settings.autorotate) {
        this.flickity.pausePlayer()
      }

      this.flickity && this.flickity.on('staticClick', (_event, _pointer, _cellElement, cellIndex) => {
        if (typeof cellIndex == 'number') {
          this.flickityNav.select(cellIndex)
        }
      })

      // Do stuff based on a successful swipe and it's direction
      this.flickity && this.flickity.on('change', (index) => {
        this.flickityNav.select(index)
      })
    })
  }

  update () {
    setTimeout(() => {
      if (this.flickity && this.flickityNav) {
        this.flickityNav.next()
        if (this.settings.autorotate) {
          this.flickity.unpausePlayer()
        }
      }
    }, 300)
  }

  getSwipeDirection (moveVector) {
    return moveVector.x > 0 ? 'right' : 'left'
  }
}

customElements.define('testimonials-component', TestimonialsComponent)

class UseAnimate extends HTMLElement {
  constructor () {
    super()

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    })
  }

  init () {
    this.setAttribute('animate', '')
  }
}

customElements.define('use-animate', UseAnimate)

class AnimateSticky extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    this.onScrollHandler = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScrollHandler, false)
    this.onScrollHandler()
  }

  disconnectedCallback () {
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  onScroll () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (scrollTop > this.getOffsetTop(this)) {
      window.requestAnimationFrame(this.reveal.bind(this))
    } else {
      window.requestAnimationFrame(this.reset.bind(this))
    }
  }

  reveal () {
    this.setAttribute('animate', '')
  }

  reset () {
    this.removeAttribute('animate')
  }

  getOffsetTop (element) {
    let offsetTop = 0
    while (element) {
      offsetTop += element.offsetTop
      element = element.offsetParent
    }
    return offsetTop
  }
}

customElements.define('animate-sticky', AnimateSticky)

class LookbookComponent extends HTMLElement {
  constructor () {
    super()

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    })
  }

  init () {
    const hotspots = this.querySelectorAll('.look__hotspot')
    hotspots.forEach((hotspot) => {
      hotspot.classList.add('is-active')
    })

    setTimeout(() => {
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove('is-active')
      })
    }, 3e3)
  }
}

customElements.define('lookbook-component', LookbookComponent)

class TabCollage extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('.tab-collage__heading').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this)),
    )

    if (this.dataset.accordion === undefined) {
      this.querySelectorAll('.tab-collage__heading').forEach(
        (button) => button.addEventListener('mouseover', this.onButtonClick.bind(this)),
      )
    }
  }

  onButtonClick (event) {
    const target = event.target
    if (target.classList.contains('is-active')) {
      if (this.dataset.accordion !== undefined) {
        target.classList.remove('is-active')
      }
      return
    }

    this.pauseAllMedia()

    this.querySelectorAll('[data-block-id]').forEach((button) => {
      if (target.dataset.blockId === button.dataset.blockId) {
        button.classList.add('is-active')
      } else {
        button.classList.remove('is-active')
      }
    })
  }

  pauseAllMedia () {
    this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
    })
    this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    })
    this.querySelectorAll('video').forEach((video) => video.pause())
    document.querySelectorAll('video').forEach((video) => video.pause())
  }
}

customElements.define('tab-collage', TabCollage)

class CountdownTimer extends HTMLElement {
  constructor () {
    super()

    this.parent = this.closest('.product-countdown')
    this.date = new Date(Date.parse(this.dataset.date)).getTime()

    if (isNaN(this.date)) {
      this.date = new Date(this.dataset.date.replace(/-/g, '/')).getTime()

      if (isNaN(this.date)) {
        this.unload()
        return
      }
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    })
  }

  init () {
    this.timer()
    this.dataset.interval = setInterval(this.timer.bind(this), 1000)
  }

  timer () {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now)

    if (timeDifference < 0) {
      this.unload()
      return
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000

    const days = Math.floor(timeDifference / (secondsInADay) * 1)
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1)
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1)
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1)

    if (this.dataset.compact == 'true') {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}${window.dateStrings.d}</span></div>` : ''
      const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : '0' + hours}:${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}</span></div>`

      this.innerHTML = dayHTML + otherHTML
    } else {
      const dayHTML = days > 0 ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? window.dateStrings.day : window.dateStrings.days}</div>` : ''
      const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? window.dateStrings.hour : window.dateStrings.hours}</div>`
      const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? window.dateStrings.minute : window.dateStrings.minutes}</div>`
      const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? window.dateStrings.second : window.dateStrings.seconds}</div>`

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML
    }
  }

  unload () {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval)
    }

    this.classList.add('hidden')
    if (this.parent) {
      this.parent.classList.add('hidden')
    }
  }
}

customElements.define('countdown-timer', CountdownTimer)

class GMap extends HTMLElement {
  constructor () {
    super()

    if (!this.dataset.apiKey || !this.dataset.mapAddress) {
      return
    }

    theme.initWhenVisible({
      element: this,
      callback: this.prepMapApi.bind(this),
      threshold: 200,
    })
  }

  prepMapApi () {
    this.loadScript().then(this.initMap.bind(this))
  }

  loadScript () {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      document.body.appendChild(script)
      script.onload = resolve
      script.onerror = reject
      script.async = true
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.dataset.apiKey
    })
  }

  initMap () {
    const geocoder = new google.maps.Geocoder()

    geocoder.geocode({ address: this.dataset.mapAddress }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        if (Shopify.designMode) {}
      } else {
        const mapOptions = {
          zoom: parseInt(this.dataset.zoom),
          center: results[0].geometry.location,
          draggable: true,
          clickableIcons: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          disableDefaultUI: true,
        }

        const map = new google.maps.Map(this, mapOptions), center = map.getCenter()

        map.setCenter(center)

        const icon = {
          path: 'M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z',
          fillColor: this.dataset.markerColor,
          fillOpacity: 1,
          anchor: new google.maps.Point(15, 55),
          strokeWeight: 0,
          scale: 0.6,
        }

        new google.maps.Marker({
          map: map,
          position: map.getCenter(),
          icon: icon,
        })

        const styledMapType = new google.maps.StyledMapType(JSON.parse(this.parentNode.querySelector('[data-gmap-style]').innerHTML))

        map.mapTypes.set('styled_map', styledMapType)
        map.setMapTypeId('styled_map')

        google.maps.event.addDomListener(window, 'resize', function () {
          google.maps.event.trigger(map, 'resize')
          map.setCenter(center)
        })
      }
    })
  }
}

customElements.define('g-map', GMap)

class RelatedButtons extends HTMLElement {
  constructor () {
    super()

    window.addEventListener('scroll', this.checkListener.bind(this))
    this.querySelectorAll('a').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this)),
    )
  }

  checkListener () {
    const element = document.querySelector(this.dataset.scrollto)
    const show = window.scrollY >= element.offsetTop - element.clientHeight

    if (show) {
      this.classList.add('is-flipped')
    } else {
      this.classList.remove('is-flipped')
    }
  }

  onButtonClick (event) {
    event.preventDefault()
    const target = event.target
    const scrollIntoView = document.querySelector(target.getAttribute('href'))

    scrollIntoView.scrollIntoView({ behavior: 'smooth' })
  }
}

customElements.define('related-buttons', RelatedButtons)

class ProductRecentlyViewed extends HTMLElement {
  constructor () {
    super()

    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported('local')) {
      const productId = parseInt(this.dataset.productId)
      const cookieName = 'beyours:recently-viewed'
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]')

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId)
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 5)))
    }
  }
}

customElements.define('product-recently-viewed', ProductRecentlyViewed)

class RecentlyViewedProducts extends HTMLElement {
  constructor () {
    super()

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    })
  }

  init () {
    fetch(this.dataset.url + this.getQueryString()).then(response => response.text()).then(text => {
      const html = document.createElement('div')
      html.innerHTML = text
      const recommendations = html.querySelector('recently-viewed-products')
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML
      }
    }).catch(e => {
      console.error(e)
    })
  }

  getQueryString () {
    const cookieName = 'beyours:recently-viewed'
    const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]')
    if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1)
    }
    return items.map((item) => 'id:' + item).slice(0, 4).join(' OR ')
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts)

class VideoSection extends HTMLElement {
  constructor () {
    super()

    this.background = this.dataset.initMode !== 'template'
    this.loop = this.dataset.loop

    if (this.background) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600,
      })
    } else {
      this.init()
    }
  }

  init () {
    this.parentSelector = this.dataset.parent || '.media-wrapper'
    this.parent = this.closest(this.parentSelector)

    switch (this.dataset.type) {
      case 'youtube':
        this.initYoutubeVideo()
        break

      case 'vimeo':
        this.initVimeoVideo()
        break

      case 'mp4':
        this.initMp4Video()
        break
    }
  }

  initYoutubeVideo () {
    this.setAsLoading()
    this.loadScript('youtube').then(this.setupYoutubePlayer.bind(this))
  }

  initVimeoVideo () {
    this.setAsLoading()
    this.loadScript('vimeo').then(this.setupVimeoPlayer.bind(this))
  }

  initMp4Video () {
    const player = this.querySelector('video')

    if (player) {
      const promise = player.play()

      // Edge does not return a promise (video still plays)
      if (typeof promise !== 'undefined') {
        promise.then(function () {
          // playback normal
        }).catch(function () {
          player.setAttribute('controls', '')
        })
      }
    }
  }

  loadScript (videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      document.body.appendChild(script)
      script.onload = resolve
      script.onerror = reject
      script.async = true
      script.src = videoType === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js'
    })
  }

  setAsLoading () {
    this.parent.setAttribute('loading', true)
  }

  setAsLoaded () {
    this.parent.removeAttribute('loading')
    this.parent.setAttribute('loaded', true)
  }

  setupYoutubePlayer () {
    const videoId = this.dataset.videoId

    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement('div')
          this.appendChild(element)

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: this.loop == '1' ? 1 : 0,
              playlist: videoId,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1,
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this),
            },
          })
          clearInterval(playerInterval)
        })
      }
    }, 50)
  }

  onYoutubeReady () {
    this.iframe = this.querySelector('iframe') // iframe once YT loads
    this.iframe.setAttribute('tabindex', '-1')

    this.background && this.player.mute()
    if (typeof this.player.playVideo === 'function') this.player.playVideo()

    this.setAsLoaded()

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.youtubePlay() : this.youtubePause()
      })
    }, { rootMargin: '0px 0px 50px 0px' })

    observer.observe(this.iframe)
  }

  onYoutubeStateChange (event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded()
          this.closest('.banner').classList.add('video-interactable')
        }
        break
      case 0: // ended, loop it
        this.youtubePlay()
        break
      case 1: // playing
        this.setAsLoaded()
        break
      case 3: // buffering
        this.attemptedToPlay = true
        break
    }
  }

  youtubePlay () {
    if (this.background && this.player && typeof this.player.playVideo === 'function') {
      this.player.playVideo()
    }
  }

  youtubePause () {
    if (this.background && this.player && typeof this.player.pauseVideo === 'function') {
      this.player.pauseVideo()
    }
  }

  setupVimeoPlayer () {
    const videoId = this.dataset.videoId

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: this.loop == '1' ? true : false,
          playlist: videoId,
          height: '100%',
          width: '100%',
        })
        this.player.ready().then(this.onVimeoReady.bind(this))

        clearInterval(playerInterval)
      }
    }, 50)
  }

  onVimeoReady () {
    this.iframe = this.querySelector('iframe')
    this.iframe.setAttribute('tabindex', '-1')

    this.background && this.player.setMuted(true)

    this.setAsLoaded()

    // pause when out of view
    const observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.vimeoPlay()
        } else {
          this.vimeoPause()
        }
      })
    }, { rootMargin: '0px 0px 50px 0px' })

    observer.observe(this.iframe)
  }

  vimeoPlay () {
    if (this.background && this.player && typeof this.player.play === 'function') {
      this.player.play()
    }
  }

  vimeoPause () {
    if (this.background && this.player && typeof this.player.pause === 'function') {
      this.player.pause()
    }
  }
}

customElements.define('video-section', VideoSection)

class BundleProduct extends HTMLElement {
  constructor () {
    super()

    this.classes = {
      souldout: 'price--sold-out',
      onsale: 'price--on-sale',
      nocompare: 'price--no-compare',
    }

    this.addToCart = this.querySelector('add-to-cart')
    this.price = this.querySelector('.price')
    this.variants = this.querySelector('select')
    if (this.variants) {
      this.variants.addEventListener('change', this.onSelectChange.bind(this))
    }
  }

  onSelectChange (event) {
    const variants = event.target
    const variant = variants.options[variants.selectedIndex]
    const compare_at_price = parseInt(variant.dataset.compare_at_price || 0)
    const price = parseInt(variant.dataset.price || 0)
    const available = variant.dataset.available === 'true'
    const price_varies = variants.dataset.price_varies === 'true'
    const compare_at_price_varies = variants.dataset.compare_at_price_varies === 'true'

    // Remove classes
    this.price.classList.remove(this.classes.souldout)
    this.price.classList.remove(this.classes.onsale)
    this.price.classList.remove(this.classes.nocompare)

    // Add classes
    if (available === false) {
      this.price.classList.add(this.classes.souldout)
    } else if (compare_at_price > price && available) {
      this.price.classList.add(this.classes.onsale)
    }
    if (price_varies == false && compare_at_price_varies) {
      this.price.classList.add(this.classes.nocompare)
    }

    // Change price
    const price__regular = this.querySelector('.price__regular')
    price__regular.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, window.shopSettings.moneyFormat)}</bdi></price-money>`

    const price__sale = this.querySelector('.price__sale')
    price__sale.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(compare_at_price, window.shopSettings.moneyFormat)}</bdi></price-money>`
    price__sale.querySelector('.price-item--sale').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, window.shopSettings.moneyFormat)}</bdi></price-money>`    

    // Change variant id
    if (this.addToCart) {
      this.addToCart.dataset.variantId = variant.value
    }
  }
}

customElements.define('bundle-product', BundleProduct)

class BundleProducts extends HTMLElement {
  constructor () {
    super()

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
    }

    this.miniCart = document.querySelector('mini-cart')
    this.button = this.querySelector('button')
    if (this.button) this.button.addEventListener('click', this.onButtonClick.bind(this))

    this.blocks = this.querySelectorAll('[data-block-id]')
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)))
    this.blocks.forEach((block) => block.addEventListener('mouseleave', this.onLeaveHandler.bind(this)))
  }

  onEnterHandler (event) {
    this.classList.add(this.classes.hover)

    const target = event.target
    const blockId = target.dataset.blockId
    this.blocks.forEach((block) => {
      if (target.nodeName === 'BUNDLE-PRODUCT') {
        if (block.nodeName === 'BUNDLE-PRODUCT') {
          block.classList.add(this.classes.active)
          return
        }
      }
      if (block.dataset.blockId === blockId) {
        block.classList.add(this.classes.active)
      }
    })
  }

  onLeaveHandler () {
    this.classList.remove(this.classes.hover)
    this.blocks.forEach((block) => block.classList.remove(this.classes.active))
  }

  onButtonClick (event) {
    event.preventDefault()

    const ids = this.querySelectorAll('[name="id"]')
    const items = {
      items: [...ids].map((e => e.value)).map((e => ({
        id: e,
        quantity: 1,
      }))),
    }

    if (document.body.classList.contains('template-cart') || !window.shopSettings.cartDrawer) {
      Shopify.postLink2(window.routes.cart_add_url, {
        parameters: {
          ...items,
        },
      })
      return
    }

    this.handleErrorMessage()

    this.button.setAttribute('disabled', true)
    this.button.classList.add('loading')
    const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : []

    const body = JSON.stringify({
      ...items,
      sections: sections,
      sections_url: window.location.pathname,
    })

    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body }).then((response) => response.json()).then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description)
        return
      }

      if (response.status === 422) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: response.description,
          },
        }))
      } else {
        this.miniCart && this.miniCart.renderContents(response)

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: response,
          },
        }))
      }
    }).catch((e) => {
      console.error(e)
    }).finally(() => {
      this.button.classList.remove('loading')
      this.button.removeAttribute('disabled')
    })
  }

  handleErrorMessage (errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')

    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    } else {
      if (errorMessage) {
        alert(errorMessage)
      }
    }
  }
}

customElements.define('bundle-products', BundleProducts)

class ShopTheLook extends HTMLElement {
  constructor () {
    super()

    if (this.dataset.blockCount == 1) {
      return
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    })
  }

  init () {
    this.products = this.querySelector('.image-with-text__products')

    this.blocks = this.querySelectorAll('lookbook-component [data-block-index]')
    this.blocks.forEach((block) => block.addEventListener('mouseenter', this.onEnterHandler.bind(this)))

    this.initSlider()
  }

  onEnterHandler (event) {
    if (this.flickity && typeof this.flickity.select === 'function') {
      const index = parseInt(event.target.dataset.blockIndex)
      this.flickity.select(index)
    }
  }

  onFocusHandler (index) {
    this.blocks.forEach((block) => {
      block.classList.remove('focus')

      if (parseInt(block.dataset.blockIndex) === index) {
        block.classList.add('focus')
      }
    })
  }

  initSlider () {
    this.flickity = new Flickity(this.products, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fade: true,
      setGallerySize: true,
      on: {
        ready: () => {
          this.onFocusHandler(0)
        },
        change: (index) => {
          this.onFocusHandler(index)
        },
      },
    })
  }
}

customElements.define('shop-the-look', ShopTheLook)

class SelectWrapper extends HTMLElement {
  constructor () {
    super()

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    })

    this.select = this.querySelector('select')
    if (this.select) {
      this.select.addEventListener('change', this.handleSelectChange.bind(this))
    }
  }

  init () {
    const style = window.getComputedStyle(this.select)
    const value = this.select.options[this.select.selectedIndex].text

    const text = document.createElement('span')
    text.style.fontFamily = style.fontFamily
    text.style.fontSize = style.fontSize
    text.style.fontWeight = style.fontWeight
    text.style.visibility = 'hidden'
    text.style.position = 'absolute'
    text.innerHTML = value

    document.body.appendChild(text)
    const width = text.clientWidth

    this.style.setProperty('--width', `${width}px`)
    text.remove()
  }

  handleSelectChange () {
    this.init()
  }
}

customElements.define('select-wrapper', SelectWrapper)

class ImageComparison extends HTMLElement {
  constructor () {
    super()

    this.active = false
    this.button = this.querySelector('button')
    this.horizontal = this.dataset.layout === 'horizontal'
    this.bodyStyleOverflowY = document.body.style.overflowY
    this.init()

    theme.initWhenVisible({
      element: this.querySelector('.image-comparison__animate'),
      callback: this.animate.bind(this),
      threshold: 0,
    })
  }

  animate () {
    this.setAttribute('animate', '')
    this.classList.add('animating')
    setTimeout(() => {
      this.classList.remove('animating')
    }, 1e3)
  }

  init () {
    this.button.addEventListener('touchstart', this.startHandler.bind(this))
    document.body.addEventListener('touchend', this.endHandler.bind(this))
    document.body.addEventListener('touchmove', this.onHandler.bind(this))

    this.button.addEventListener('mousedown', this.startHandler.bind(this))
    document.body.addEventListener('mouseup', this.endHandler.bind(this))
    document.body.addEventListener('mousemove', this.onHandler.bind(this))
  }

  startHandler () {
    if (window.innerWidth <= 750) {
      document.body.style.overflowY = 'hidden'
    }

    this.active = true
    this.classList.add('scrolling')
  }

  endHandler () {
    this.active = false
    this.classList.remove('scrolling')
    document.body.style.overflowY = this.bodyStyleOverflowY
  }

  onHandler (e) {
    if (!this.active) return

    const event = (e.touches && e.touches[0]) || e
    const x = this.horizontal
      ? event.pageX - this.offsetLeft
      : event.pageY - this.offsetTop

    this.scrollIt(x)
  }

  scrollIt (x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight

    const max = distance - 20
    const min = 20
    const mouseX = Math.max(min, (Math.min(x, max)))
    const mousePercent = (mouseX * 100) / distance
    this.style.setProperty('--percent', mousePercent + '%')
  }
}

customElements.define('image-comparison', ImageComparison)

class ScrollingPromotion extends HTMLElement {
  constructor () {
    super()

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    }

    this.promotion = this.querySelector('.promotion')

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    })
  }

  init () {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated')

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true)
        this.clone.setAttribute('aria-hidden', true)
        this.appendChild(this.clone)

        const imageWrapper = this.clone.querySelector('.media-wrapper')
        if (imageWrapper) {
          imageWrapper.classList.remove('loading')
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime
      this.style.setProperty('--duration', `${animationTimeFrame}s`)

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay()
          } else {
            this.scrollingPause()
          }
        })
      }, { rootMargin: '0px 0px 50px 0px' })

      observer.observe(this)
    }
  }

  scrollingPlay () {
    this.classList.remove('scrolling-promotion--paused')
  }

  scrollingPause () {
    this.classList.add('scrolling-promotion--paused')
  }
}

customElements.define('scrolling-promotion', ScrollingPromotion)

class AccordionTab extends HTMLElement {
  constructor () {
    super()

    this.details = this.querySelector('details')
    this.summary = this.querySelector('summary')
    this.content = this.querySelector('.accordion__content')

    this.animation = null
    this.isClosing = false
    this.isExpanding = false

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    })
  }

  init () {
    this.summary.addEventListener('click', (e) => this.onClick(e))
  }

  onClick (e) {
    e.preventDefault()

    this.details.style.overflow = 'hidden'
    if (this.isClosing || !this.details.open) {
      this.open()
    } else if (this.isExpanding || this.details.open) {
      this.shrink()
    }
  }

  shrink () {
    this.isClosing = true

    const summaryStyle = window.getComputedStyle(this.summary)
    const startHeight = `${this.details.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)}px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.details.animate({
      height: [startHeight, endHeight],
    }, {
      duration: 250,
      easing: 'ease',
    })

    this.animation.onfinish = () => this.onAnimationFinish(false)
    this.animation.oncancel = () => this.isClosing = false
  }

  open () {
    this.details.style.height = `${this.details.offsetHeight}px`
    this.details.open = true
    window.requestAnimationFrame(() => this.expand())
  }

  expand () {
    this.isExpanding = true

    const summaryStyle = window.getComputedStyle(this.summary)
    const startHeight = `${this.details.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop) + this.content.offsetHeight}px`

    if (this.animation) {
      this.animation.cancel()
    }

    this.animation = this.details.animate({
      height: [startHeight, endHeight],
    }, {
      duration: 400,
      easing: 'ease-out',
    })
    this.animation.onfinish = () => this.onAnimationFinish(true)
    this.animation.oncancel = () => this.isExpanding = false
  }

  onAnimationFinish (open) {
    this.details.open = open
    this.animation = null
    this.isClosing = false
    this.isExpanding = false
    this.details.style.height = this.details.style.overflow = ''
  }
}

customElements.define('accordion-tab', AccordionTab)

class ProductRecommendations extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 600px 0px' }).observe(this)
  }

  handleIntersection (entries, observer) {
    if (!entries[0].isIntersecting) return
    observer.unobserve(this)

    fetch(this.dataset.url).then(response => response.text()).then(text => {
      const html = document.createElement('div')
      html.innerHTML = text
      const recommendations = html.querySelector('product-recommendations')
      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML
      }
    }).catch(e => {
      console.error(e)
    })
  }
}

customElements.define('product-recommendations', ProductRecommendations)

class HeaderMenuToggle extends HTMLElement {
  constructor () {
    super()

    this.header = document.querySelector('.shopify-section-header')
    this.addEventListener('click', this.onButtonClick.bind(this))
  }

  onButtonClick () {
    this.header.classList.toggle('shopify-section-header-menu-open')
  }
}

customElements.define('header-menu-toggle', HeaderMenuToggle)

class UpsellProduct extends HTMLElement {
  constructor () {
    super()
    this.querySelectorAll('input[type="radio"]').forEach(el => {
      el.addEventListener('change', this.variationChange)
    })
  }

  variationChange = (event) => {
    let price = event.target.getAttribute('data-price')
    this.querySelector('.price').innerHTML = price
  }

}

customElements.define('upsell-product', UpsellProduct)
